// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { allowsInterestPolicyList, androidCallback, availCardList, bankList, bannerList, bestContentsFeedback, calculateDonation, callbackComplete, cardList, certificationCheck, checkPlusSuccess, commonCodeInit, commonCodeInit1, createApiCounsel, detailWelloLanding, expositionLinkUrlList, faqList, feedbackCommunityWelloNews, feedbackPointMarketProduct, fileDecryptionDownload, fileDelete, fileUpload, findAllInquiries, findArticle, findArticleFeedback, findBestContents, findDonationBusinesses, findFeeds, findGeneralDownloadableCoupons, findGiftProducts, findGoodPointTypes, findHometownNews, findInquiry, findLocalMarketProducts, findMonthlyThemes, findPhotoReviews, findPolicies, findQueryAgeCode, findQueryJobCode, findQueryProvisionCode, findQueryTargetCode, findReview, findReviews, findThemeArticles, findThemeFestivals, findTourDistance, findTourFeedback, findTourFestival, findTourFestivals, findTourLclsSystmCodeList, findTourReviews, geolocation, getActiveMaintenanceList, getAdminHomeSearchKeywordList, getApiPolicyList, getApiPolicyNameList, getApiProductNameList, getApiTheme, getApiThemeKeywordNameList, getApiThemeList, getApiThemeNameList, getBestContents, getCommunityCategory, getCommunityMainCategoryList, getCommunitySubcategoryListByCode, getCommunityWelloNews, getCommunityWelloNewsList, getControlManagements, getDecemberEventGiftProductList, getDecemberInstitutionEventInfoList, getDecemberRandomTicketWinnerList, getDonationBusiness, getDonationBusinessCommentList, getDonationBusinessDetailCount, getDonationBusinessList, getEmergencyRoom, getEmergencyRoomCodeList, getEmergencyRoomList, getEmergencyRoomListCount, getEmergencyRoomLive, getEmergencyRoomRegionList, getEventAmountInfo, getGiftOrderProductPhotoReviewListByProduct, getGiftOrderProductReview, getGiftOrderProductReviewList, getGiftProduct, getGiftProductBlockList, getGiftProductList, getGiftProductList1, getGiftProductListByInstitution, getGiftProductPopularByInstitutionList, getGiftProductSeo, getGiftReviewFeed, getHomeDonationEvent, getHomeDonationHistoryByDonationBusinessList, getHomeDonationStatisticsList, getHomeInquiry, getHomeInquiryList, getHomeInstitution, getHomeInstitutionBenefitList, getHomeInstitutionBenefitListAll, getHomeInstitutionBenefitPrivateList, getHomeInstitutionBenefitPublicList, getHomeInstitutionBenefitRegionList, getHomeInstitutionContent, getHomeInstitutionContentList, getHomeInstitutionDonationBusiness, getHomeInstitutionEvent, getHomeInstitutionEventList, getHomeInstitutionListForSearchFilter, getHomeInstitutionPolicyList, getHomeInstitutionWithGiftProductList, getHomeLoveGovCodeToId, getHomeLoveMainDailyPickList, getHomeLoveMainFeaturedDonationBusinessesList, getHomeLoveMainInstitutionSpecialtyList, getHomeLoveMainRecommendedInstitutionList, getHomeNotice, getHomeNoticeList, getHomePopupNotice, getHomeWelloPolicyApplyList, getInstitutionGiftProductList, getInstitutionRelatedDonationBusiness, getInstitutionSpecialtyList, getKbMemberLoginTypeList, getListChildcarePolicyBudget, getListChildcareRelatedPolicy, getListPolicyCaseCategory, getLiveWelloCommentList, getMaintenance, getMedianIncomeList, getMemberNameByInviteCode, getMetaPolicyCommentList, getMetaPolicyCommentList1, getNCloudGeocodingByCode, getNonMemberSuggestPolicyList, getOrderedHomeInstitutionEventList, getPointBudget, getPointEarning, getPointInfo, getPointMarketBrandList, getPointMarketProduct, getPointMarketProductList, getPointMarketProductListByBrand, getPolicyCodeGeocodingList, getPolicyDictionaryList, getPopularPointMarketProductList, getPrimaryGiftCategoryList, getProductDetail, getProductDetailByProductNumber, getProductFeedList, getProductSeo, getProductSeoByProductId, getRecentDonatedGiftItems, getRecentEventHistoryList, getRecentEventHistoryListInSeptember, getRecentOpenedGiftBoxList, getRelatedDonationBusiness, getRelatedGiftProductList, getRelatedHometownNewsList, getSituationPolicyList, getTopDonationEventHistoryList, getTopInviterListInAugust, getUrlMapping, getWeeklyBestGiftPhotoReviews, getWelcomeMonitorDisplayList, getWelloPickBannerList, getWelloQuickMenuList, handleAuthResult, handleNicePayWebhook, hometownNews, hometownNewsFeedback, iosCallback, isEventInProgress, joinEvent, kbWelloPolicyCodeAllList, loginWelloSnsMember, loginWelloWithKbPay, messageReceive, metaCodeAll, metaPolicy, metaPolicyFeedback, newWelloAppPushCnt, notice, noticeList, noticeList1, type Options, popularPolicyList, rejectMessage, resignMember, resignWelloWithKbPay, reverseGeocoding, saveAllowsWelloDeviceInfo, saveLoginResult, saveWelloNonmemberRegion, saveWelloTracking, searchGiftProductList, searchGiftProductListByContains, searchGiftProductListCount, sendCertificationCellphone, sendExtAppPush, situationList, snsRefreshToken, term, termHistory, updateFileTempSaveYn, updateMessageReceive, updatePolicyAiInfo, updateWelloAppPushRead, updateWelloAppPushRead1, viewHomeGiftProduct, welloAppPushList, welloBeforeLogin, welloPickList, welloPickPolicyList, welloPolicyCodeAllList, welloPolicyCodeBabyList, welloPolicyCodeList } from '../sdk.gen';
import type { AllowsInterestPolicyListData, AllowsInterestPolicyListError, AllowsInterestPolicyListResponse, AndroidCallbackData, AndroidCallbackError, AndroidCallbackResponse, AvailCardListData, AvailCardListError, AvailCardListResponse, BankListData, BankListError, BankListResponse, BannerListData, BannerListError, BannerListResponse, BestContentsFeedbackData, BestContentsFeedbackError, BestContentsFeedbackResponse, CalculateDonationData, CalculateDonationError, CalculateDonationResponse, CallbackCompleteData, CallbackCompleteError, CardListData, CardListError, CardListResponse, CertificationCheckData, CertificationCheckError, CertificationCheckResponse, CheckPlusSuccessData, CheckPlusSuccessError, CheckPlusSuccessResponse, CommonCodeInit1Data, CommonCodeInit1Error, CommonCodeInit1Response, CommonCodeInitData, CommonCodeInitError, CommonCodeInitResponse, CreateApiCounselData, CreateApiCounselError, CreateApiCounselResponse, DetailWelloLandingData, DetailWelloLandingError, DetailWelloLandingResponse2, ExpositionLinkUrlListData, ExpositionLinkUrlListError, ExpositionLinkUrlListResponse, FaqListData, FaqListError, FaqListResponse, FeedbackCommunityWelloNewsData, FeedbackCommunityWelloNewsError, FeedbackCommunityWelloNewsResponse, FeedbackPointMarketProductData, FeedbackPointMarketProductError, FeedbackPointMarketProductResponse, FileDecryptionDownloadData, FileDecryptionDownloadError, FileDecryptionDownloadResponse, FileDeleteData, FileDeleteError, FileDeleteResponse, FileUploadData, FileUploadError, FileUploadResponse, FindAllInquiriesData, FindAllInquiriesError, FindAllInquiriesResponse, FindArticleData, FindArticleError, FindArticleFeedbackData, FindArticleFeedbackError, FindArticleFeedbackResponse, FindArticleResponse, FindBestContentsData, FindBestContentsError, FindBestContentsResponse, FindDonationBusinessesData, FindDonationBusinessesError, FindDonationBusinessesResponse, FindFeedsData, FindFeedsError, FindFeedsResponse, FindGeneralDownloadableCouponsData, FindGeneralDownloadableCouponsError, FindGeneralDownloadableCouponsResponse, FindGiftProductsData, FindGiftProductsError, FindGiftProductsResponse, FindGoodPointTypesData, FindGoodPointTypesError, FindGoodPointTypesResponse, FindHometownNewsData, FindHometownNewsError, FindHometownNewsResponse, FindInquiryData, FindInquiryError, FindInquiryResponse, FindLocalMarketProductsData, FindLocalMarketProductsError, FindLocalMarketProductsResponse, FindMonthlyThemesData, FindMonthlyThemesError, FindMonthlyThemesResponse, FindPhotoReviewsData, FindPhotoReviewsError, FindPhotoReviewsResponse, FindPoliciesData, FindPoliciesError, FindPoliciesResponse, FindQueryAgeCodeData, FindQueryAgeCodeError, FindQueryAgeCodeResponse, FindQueryJobCodeData, FindQueryJobCodeError, FindQueryJobCodeResponse, FindQueryProvisionCodeData, FindQueryProvisionCodeError, FindQueryProvisionCodeResponse, FindQueryTargetCodeData, FindQueryTargetCodeError, FindQueryTargetCodeResponse, FindReviewData, FindReviewError, FindReviewResponse, FindReviewsData, FindReviewsError, FindReviewsResponse, FindThemeArticlesData, FindThemeArticlesError, FindThemeArticlesResponse, FindThemeFestivalsData, FindThemeFestivalsError, FindThemeFestivalsResponse, FindTourDistanceData, FindTourDistanceError, FindTourDistanceResponse, FindTourFeedbackData, FindTourFeedbackError, FindTourFeedbackResponse, FindTourFestivalData, FindTourFestivalError, FindTourFestivalResponse, FindTourFestivalsData, FindTourFestivalsError, FindTourFestivalsResponse, FindTourLclsSystmCodeListData, FindTourLclsSystmCodeListError, FindTourLclsSystmCodeListResponse, FindTourReviewsData, FindTourReviewsError, FindTourReviewsResponse, GeolocationData, GeolocationError, GeolocationResponse, GetActiveMaintenanceListData, GetActiveMaintenanceListError, GetActiveMaintenanceListResponse, GetAdminHomeSearchKeywordListData, GetAdminHomeSearchKeywordListError, GetAdminHomeSearchKeywordListResponse, GetApiPolicyListData, GetApiPolicyListError, GetApiPolicyListResponse, GetApiPolicyNameListData, GetApiPolicyNameListError, GetApiPolicyNameListResponse, GetApiProductNameListData, GetApiProductNameListError, GetApiProductNameListResponse, GetApiThemeData, GetApiThemeError, GetApiThemeKeywordNameListData, GetApiThemeKeywordNameListError, GetApiThemeKeywordNameListResponse, GetApiThemeListData, GetApiThemeListError, GetApiThemeListResponse, GetApiThemeNameListData, GetApiThemeNameListError, GetApiThemeNameListResponse, GetApiThemeResponse, GetBestContentsData, GetBestContentsError, GetBestContentsResponse, GetCommunityCategoryData, GetCommunityCategoryError, GetCommunityCategoryResponse, GetCommunityMainCategoryListData, GetCommunityMainCategoryListError, GetCommunityMainCategoryListResponse, GetCommunitySubcategoryListByCodeData, GetCommunitySubcategoryListByCodeError, GetCommunitySubcategoryListByCodeResponse, GetCommunityWelloNewsData, GetCommunityWelloNewsError, GetCommunityWelloNewsListData, GetCommunityWelloNewsListError, GetCommunityWelloNewsListResponse, GetCommunityWelloNewsResponse, GetControlManagementsData, GetControlManagementsError, GetControlManagementsResponse, GetDecemberEventGiftProductListData, GetDecemberEventGiftProductListError, GetDecemberEventGiftProductListResponse, GetDecemberInstitutionEventInfoListData, GetDecemberInstitutionEventInfoListError, GetDecemberInstitutionEventInfoListResponse, GetDecemberRandomTicketWinnerListData, GetDecemberRandomTicketWinnerListError, GetDecemberRandomTicketWinnerListResponse, GetDonationBusinessCommentListData, GetDonationBusinessCommentListError, GetDonationBusinessCommentListResponse, GetDonationBusinessData, GetDonationBusinessDetailCountData, GetDonationBusinessDetailCountError, GetDonationBusinessDetailCountResponse, GetDonationBusinessError, GetDonationBusinessListData, GetDonationBusinessListError, GetDonationBusinessListResponse, GetDonationBusinessResponse, GetEmergencyRoomCodeListData, GetEmergencyRoomCodeListError, GetEmergencyRoomCodeListResponse, GetEmergencyRoomData, GetEmergencyRoomError, GetEmergencyRoomListCountData, GetEmergencyRoomListCountError, GetEmergencyRoomListCountResponse, GetEmergencyRoomListData, GetEmergencyRoomListError, GetEmergencyRoomListResponse, GetEmergencyRoomLiveData, GetEmergencyRoomLiveError, GetEmergencyRoomLiveResponse, GetEmergencyRoomRegionListData, GetEmergencyRoomRegionListError, GetEmergencyRoomRegionListResponse, GetEmergencyRoomResponse, GetEventAmountInfoData, GetEventAmountInfoError, GetEventAmountInfoResponse, GetGiftOrderProductPhotoReviewListByProductData, GetGiftOrderProductPhotoReviewListByProductError, GetGiftOrderProductPhotoReviewListByProductResponse, GetGiftOrderProductReviewData, GetGiftOrderProductReviewError, GetGiftOrderProductReviewListData, GetGiftOrderProductReviewListError, GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewResponse, GetGiftProductBlockListData, GetGiftProductBlockListError, GetGiftProductBlockListResponse, GetGiftProductData, GetGiftProductError, GetGiftProductList1Data, GetGiftProductList1Error, GetGiftProductList1Response, GetGiftProductListByInstitutionData, GetGiftProductListByInstitutionError, GetGiftProductListByInstitutionResponse, GetGiftProductListData, GetGiftProductListError, GetGiftProductListResponse, GetGiftProductPopularByInstitutionListData, GetGiftProductPopularByInstitutionListError, GetGiftProductPopularByInstitutionListResponse, GetGiftProductResponse, GetGiftProductSeoData, GetGiftProductSeoError, GetGiftProductSeoResponse, GetGiftReviewFeedData, GetGiftReviewFeedError, GetGiftReviewFeedResponse, GetHomeDonationEventData, GetHomeDonationEventError, GetHomeDonationEventResponse, GetHomeDonationHistoryByDonationBusinessListData, GetHomeDonationHistoryByDonationBusinessListError, GetHomeDonationHistoryByDonationBusinessListResponse, GetHomeDonationStatisticsListData, GetHomeDonationStatisticsListError, GetHomeDonationStatisticsListResponse, GetHomeInquiryData, GetHomeInquiryError, GetHomeInquiryListData, GetHomeInquiryListError, GetHomeInquiryListResponse, GetHomeInquiryResponse, GetHomeInstitutionBenefitListAllData, GetHomeInstitutionBenefitListAllError, GetHomeInstitutionBenefitListAllResponse, GetHomeInstitutionBenefitListData, GetHomeInstitutionBenefitListError, GetHomeInstitutionBenefitListResponse, GetHomeInstitutionBenefitPrivateListData, GetHomeInstitutionBenefitPrivateListError, GetHomeInstitutionBenefitPrivateListResponse, GetHomeInstitutionBenefitPublicListData, GetHomeInstitutionBenefitPublicListError, GetHomeInstitutionBenefitPublicListResponse, GetHomeInstitutionBenefitRegionListData, GetHomeInstitutionBenefitRegionListError, GetHomeInstitutionBenefitRegionListResponse, GetHomeInstitutionContentData, GetHomeInstitutionContentError, GetHomeInstitutionContentListData, GetHomeInstitutionContentListError, GetHomeInstitutionContentListResponse, GetHomeInstitutionContentResponse, GetHomeInstitutionData, GetHomeInstitutionDonationBusinessData, GetHomeInstitutionDonationBusinessError, GetHomeInstitutionDonationBusinessResponse, GetHomeInstitutionError, GetHomeInstitutionEventData, GetHomeInstitutionEventError, GetHomeInstitutionEventListData, GetHomeInstitutionEventListError, GetHomeInstitutionEventListResponse, GetHomeInstitutionEventResponse, GetHomeInstitutionListForSearchFilterData, GetHomeInstitutionListForSearchFilterError, GetHomeInstitutionListForSearchFilterResponse, GetHomeInstitutionPolicyListData, GetHomeInstitutionPolicyListError, GetHomeInstitutionPolicyListResponse, GetHomeInstitutionResponse, GetHomeInstitutionWithGiftProductListData, GetHomeInstitutionWithGiftProductListError, GetHomeInstitutionWithGiftProductListResponse, GetHomeLoveGovCodeToIdData, GetHomeLoveGovCodeToIdError, GetHomeLoveGovCodeToIdResponse, GetHomeLoveMainDailyPickListData, GetHomeLoveMainDailyPickListError, GetHomeLoveMainDailyPickListResponse, GetHomeLoveMainFeaturedDonationBusinessesListData, GetHomeLoveMainFeaturedDonationBusinessesListError, GetHomeLoveMainFeaturedDonationBusinessesListResponse, GetHomeLoveMainInstitutionSpecialtyListData, GetHomeLoveMainInstitutionSpecialtyListError, GetHomeLoveMainInstitutionSpecialtyListResponse, GetHomeLoveMainRecommendedInstitutionListData, GetHomeLoveMainRecommendedInstitutionListError, GetHomeLoveMainRecommendedInstitutionListResponse, GetHomeNoticeData, GetHomeNoticeError, GetHomeNoticeListData, GetHomeNoticeListError, GetHomeNoticeListResponse, GetHomeNoticeResponse, GetHomePopupNoticeData, GetHomePopupNoticeError, GetHomePopupNoticeResponse, GetHomeWelloPolicyApplyListData, GetHomeWelloPolicyApplyListError, GetHomeWelloPolicyApplyListResponse, GetInstitutionGiftProductListData, GetInstitutionGiftProductListError, GetInstitutionGiftProductListResponse, GetInstitutionRelatedDonationBusinessData, GetInstitutionRelatedDonationBusinessError, GetInstitutionRelatedDonationBusinessResponse, GetInstitutionSpecialtyListData, GetInstitutionSpecialtyListError, GetInstitutionSpecialtyListResponse, GetKbMemberLoginTypeListData, GetKbMemberLoginTypeListError, GetKbMemberLoginTypeListResponse, GetListChildcarePolicyBudgetData, GetListChildcarePolicyBudgetError, GetListChildcarePolicyBudgetResponse, GetListChildcareRelatedPolicyData, GetListChildcareRelatedPolicyError, GetListChildcareRelatedPolicyResponse, GetListPolicyCaseCategoryData, GetListPolicyCaseCategoryError, GetListPolicyCaseCategoryResponse, GetLiveWelloCommentListData, GetLiveWelloCommentListError, GetLiveWelloCommentListResponse, GetMaintenanceData, GetMaintenanceError, GetMaintenanceResponse, GetMedianIncomeListData, GetMedianIncomeListError, GetMedianIncomeListResponse, GetMemberNameByInviteCodeData, GetMemberNameByInviteCodeError, GetMemberNameByInviteCodeResponse, GetMetaPolicyCommentList1Data, GetMetaPolicyCommentList1Error, GetMetaPolicyCommentList1Response, GetMetaPolicyCommentListData, GetMetaPolicyCommentListError, GetMetaPolicyCommentListResponse, GetNCloudGeocodingByCodeData, GetNCloudGeocodingByCodeError, GetNCloudGeocodingByCodeResponse, GetNonMemberSuggestPolicyListData, GetNonMemberSuggestPolicyListError, GetNonMemberSuggestPolicyListResponse, GetOrderedHomeInstitutionEventListData, GetOrderedHomeInstitutionEventListError, GetOrderedHomeInstitutionEventListResponse, GetPointBudgetData, GetPointBudgetError, GetPointBudgetResponse, GetPointEarningData, GetPointEarningError, GetPointEarningResponse, GetPointInfoData, GetPointInfoError, GetPointInfoResponse, GetPointMarketBrandListData, GetPointMarketBrandListError, GetPointMarketBrandListResponse, GetPointMarketProductData, GetPointMarketProductError, GetPointMarketProductListByBrandData, GetPointMarketProductListByBrandError, GetPointMarketProductListByBrandResponse, GetPointMarketProductListData, GetPointMarketProductListError, GetPointMarketProductListResponse, GetPointMarketProductResponse, GetPolicyCodeGeocodingListData, GetPolicyCodeGeocodingListError, GetPolicyCodeGeocodingListResponse, GetPolicyDictionaryListData, GetPolicyDictionaryListError, GetPolicyDictionaryListResponse, GetPopularPointMarketProductListData, GetPopularPointMarketProductListError, GetPopularPointMarketProductListResponse, GetPrimaryGiftCategoryListData, GetPrimaryGiftCategoryListError, GetPrimaryGiftCategoryListResponse, GetProductDetailByProductNumberData, GetProductDetailByProductNumberError, GetProductDetailByProductNumberResponse, GetProductDetailData, GetProductDetailError, GetProductDetailResponse, GetProductFeedListData, GetProductFeedListError, GetProductFeedListResponse, GetProductSeoByProductIdData, GetProductSeoByProductIdError, GetProductSeoByProductIdResponse, GetProductSeoData, GetProductSeoError, GetProductSeoResponse, GetRecentDonatedGiftItemsData, GetRecentDonatedGiftItemsError, GetRecentDonatedGiftItemsResponse, GetRecentEventHistoryListData, GetRecentEventHistoryListError, GetRecentEventHistoryListInSeptemberData, GetRecentEventHistoryListInSeptemberError, GetRecentEventHistoryListInSeptemberResponse, GetRecentEventHistoryListResponse, GetRecentOpenedGiftBoxListData, GetRecentOpenedGiftBoxListError, GetRecentOpenedGiftBoxListResponse, GetRelatedDonationBusinessData, GetRelatedDonationBusinessError, GetRelatedDonationBusinessResponse, GetRelatedGiftProductListData, GetRelatedGiftProductListError, GetRelatedGiftProductListResponse, GetRelatedHometownNewsListData, GetRelatedHometownNewsListError, GetRelatedHometownNewsListResponse, GetSituationPolicyListData, GetSituationPolicyListError, GetSituationPolicyListResponse, GetTopDonationEventHistoryListData, GetTopDonationEventHistoryListError, GetTopDonationEventHistoryListResponse, GetTopInviterListInAugustData, GetTopInviterListInAugustError, GetTopInviterListInAugustResponse, GetUrlMappingData, GetUrlMappingError, GetUrlMappingResponse, GetWeeklyBestGiftPhotoReviewsData, GetWeeklyBestGiftPhotoReviewsError, GetWeeklyBestGiftPhotoReviewsResponse, GetWelcomeMonitorDisplayListData, GetWelcomeMonitorDisplayListError, GetWelcomeMonitorDisplayListResponse, GetWelloPickBannerListData, GetWelloPickBannerListError, GetWelloPickBannerListResponse, GetWelloQuickMenuListData, GetWelloQuickMenuListError, GetWelloQuickMenuListResponse, HandleAuthResultData, HandleAuthResultError, HandleNicePayWebhookData, HandleNicePayWebhookError, HandleNicePayWebhookResponse, HometownNewsData, HometownNewsError, HometownNewsFeedbackData, HometownNewsFeedbackError, HometownNewsFeedbackResponse, HometownNewsResponse, IosCallbackData, IosCallbackError, IosCallbackResponse, IsEventInProgressData, IsEventInProgressError, IsEventInProgressResponse, JoinEventData, JoinEventError, JoinEventResponse, KbWelloPolicyCodeAllListData, KbWelloPolicyCodeAllListError, KbWelloPolicyCodeAllListResponse, LoginWelloSnsMemberData, LoginWelloSnsMemberError, LoginWelloSnsMemberResponse, LoginWelloWithKbPayData, LoginWelloWithKbPayError, LoginWelloWithKbPayResponse, MessageReceiveData, MessageReceiveError, MessageReceiveResponse, MetaCodeAllData, MetaCodeAllError, MetaCodeAllResponse2, MetaPolicyData, MetaPolicyError, MetaPolicyFeedbackData, MetaPolicyFeedbackError, MetaPolicyFeedbackResponse, MetaPolicyResponse, NewWelloAppPushCntData, NewWelloAppPushCntError, NewWelloAppPushCntResponse, NoticeData, NoticeError, NoticeList1Data, NoticeList1Error, NoticeList1Response, NoticeListData, NoticeListError, NoticeListResponse, NoticeResponse, PopularPolicyListData, PopularPolicyListError, PopularPolicyListResponse, RejectMessageData, RejectMessageError, RejectMessageResponse, ResignMemberData, ResignMemberError, ResignMemberResponse, ResignWelloWithKbPayData, ResignWelloWithKbPayError, ResignWelloWithKbPayResponse, ReverseGeocodingData, ReverseGeocodingError, ReverseGeocodingResponse2, SaveAllowsWelloDeviceInfoData, SaveAllowsWelloDeviceInfoError, SaveAllowsWelloDeviceInfoResponse, SaveLoginResultData, SaveLoginResultError, SaveLoginResultResponse, SaveWelloNonmemberRegionData, SaveWelloNonmemberRegionError, SaveWelloNonmemberRegionResponse, SaveWelloTrackingData, SaveWelloTrackingError, SaveWelloTrackingResponse, SearchGiftProductListByContainsData, SearchGiftProductListByContainsError, SearchGiftProductListByContainsResponse, SearchGiftProductListCountData, SearchGiftProductListCountError, SearchGiftProductListCountResponse, SearchGiftProductListData, SearchGiftProductListError, SearchGiftProductListResponse, SendCertificationCellphoneData, SendCertificationCellphoneError, SendCertificationCellphoneResponse, SendExtAppPushData, SendExtAppPushError, SendExtAppPushResponse, SituationListData, SituationListError, SituationListResponse2, SnsRefreshTokenData, SnsRefreshTokenError, SnsRefreshTokenResponse, TermData, TermError, TermHistoryData, TermHistoryError, TermHistoryResponse, TermResponse, UpdateFileTempSaveYnData, UpdateFileTempSaveYnError, UpdateFileTempSaveYnResponse, UpdateMessageReceiveData, UpdateMessageReceiveError, UpdateMessageReceiveResponse, UpdatePolicyAiInfoData, UpdatePolicyAiInfoError, UpdatePolicyAiInfoResponse, UpdateWelloAppPushRead1Data, UpdateWelloAppPushRead1Error, UpdateWelloAppPushRead1Response, UpdateWelloAppPushReadData, UpdateWelloAppPushReadError, UpdateWelloAppPushReadResponse, ViewHomeGiftProductData, ViewHomeGiftProductError, ViewHomeGiftProductResponse, WelloAppPushListData, WelloAppPushListError, WelloAppPushListResponse, WelloBeforeLoginData, WelloBeforeLoginError, WelloBeforeLoginResponse, WelloPickListData, WelloPickListError, WelloPickListResponse, WelloPickPolicyListData, WelloPickPolicyListError, WelloPickPolicyListResponse, WelloPolicyCodeAllListData, WelloPolicyCodeAllListError, WelloPolicyCodeAllListResponse, WelloPolicyCodeBabyListData, WelloPolicyCodeBabyListError, WelloPolicyCodeBabyListResponse, WelloPolicyCodeListData, WelloPolicyCodeListError, WelloPolicyCodeListResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const messageReceiveQueryKey = (options: Options<MessageReceiveData>) => createQueryKey('messageReceive', options);

/**
 * 알림수신여부 조회
 *
 * 알림수신 여부를 조회합니다
 */
export const messageReceiveOptions = (options: Options<MessageReceiveData>) => queryOptions<MessageReceiveResponse, MessageReceiveError, MessageReceiveResponse, ReturnType<typeof messageReceiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await messageReceive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: messageReceiveQueryKey(options)
});

/**
 * 알림수신여부 수정
 *
 * 알림수신 여부를 수정합니다
 */
export const updateMessageReceiveMutation = (options?: Partial<Options<UpdateMessageReceiveData>>): UseMutationOptions<UpdateMessageReceiveResponse, UpdateMessageReceiveError, Options<UpdateMessageReceiveData>> => {
    const mutationOptions: UseMutationOptions<UpdateMessageReceiveResponse, UpdateMessageReceiveError, Options<UpdateMessageReceiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMessageReceive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const welloAppPushListQueryKey = (options: Options<WelloAppPushListData>) => createQueryKey('welloAppPushList', options);

/**
 * 웰로 앱 푸시 목록 조회
 */
export const welloAppPushListOptions = (options: Options<WelloAppPushListData>) => queryOptions<WelloAppPushListResponse, WelloAppPushListError, WelloAppPushListResponse, ReturnType<typeof welloAppPushListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloAppPushList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloAppPushListQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const welloAppPushListInfiniteQueryKey = (options: Options<WelloAppPushListData>): QueryKey<Options<WelloAppPushListData>> => createQueryKey('welloAppPushList', options, true);

/**
 * 웰로 앱 푸시 목록 조회
 */
export const welloAppPushListInfiniteOptions = (options: Options<WelloAppPushListData>) => infiniteQueryOptions<WelloAppPushListResponse, WelloAppPushListError, InfiniteData<WelloAppPushListResponse>, QueryKey<Options<WelloAppPushListData>>, number | Pick<QueryKey<Options<WelloAppPushListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<WelloAppPushListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await welloAppPushList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloAppPushListInfiniteQueryKey(options)
});

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const updateWelloAppPushReadMutation = (options?: Partial<Options<UpdateWelloAppPushReadData>>): UseMutationOptions<UpdateWelloAppPushReadResponse, UpdateWelloAppPushReadError, Options<UpdateWelloAppPushReadData>> => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushReadResponse, UpdateWelloAppPushReadError, Options<UpdateWelloAppPushReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWelloAppPushRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 파일 삭제
 */
export const fileDeleteMutation = (options?: Partial<Options<FileDeleteData>>): UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> => {
    const mutationOptions: UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 파일 업로드
 */
export const fileUploadMutation = (options?: Partial<Options<FileUploadData>>): UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> => {
    const mutationOptions: UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const updateFileTempSaveYnMutation = (options?: Partial<Options<UpdateFileTempSaveYnData>>): UseMutationOptions<UpdateFileTempSaveYnResponse, UpdateFileTempSaveYnError, Options<UpdateFileTempSaveYnData>> => {
    const mutationOptions: UseMutationOptions<UpdateFileTempSaveYnResponse, UpdateFileTempSaveYnError, Options<UpdateFileTempSaveYnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFileTempSaveYn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 정책 AI 정보 업데이트
 */
export const updatePolicyAiInfoMutation = (options?: Partial<Options<UpdatePolicyAiInfoData>>): UseMutationOptions<UpdatePolicyAiInfoResponse, UpdatePolicyAiInfoError, Options<UpdatePolicyAiInfoData>> => {
    const mutationOptions: UseMutationOptions<UpdatePolicyAiInfoResponse, UpdatePolicyAiInfoError, Options<UpdatePolicyAiInfoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePolicyAiInfo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectMessageMutation = (options?: Partial<Options<RejectMessageData>>): UseMutationOptions<RejectMessageResponse, RejectMessageError, Options<RejectMessageData>> => {
    const mutationOptions: UseMutationOptions<RejectMessageResponse, RejectMessageError, Options<RejectMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 웰로 비회원 트래킹 정보 저장
 */
export const saveWelloTrackingMutation = (options?: Partial<Options<SaveWelloTrackingData>>): UseMutationOptions<SaveWelloTrackingResponse, SaveWelloTrackingError, Options<SaveWelloTrackingData>> => {
    const mutationOptions: UseMutationOptions<SaveWelloTrackingResponse, SaveWelloTrackingError, Options<SaveWelloTrackingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveWelloTracking({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 비회원 대상지역 정보 저장
 */
export const saveWelloNonmemberRegionMutation = (options?: Partial<Options<SaveWelloNonmemberRegionData>>): UseMutationOptions<SaveWelloNonmemberRegionResponse, SaveWelloNonmemberRegionError, Options<SaveWelloNonmemberRegionData>> => {
    const mutationOptions: UseMutationOptions<SaveWelloNonmemberRegionResponse, SaveWelloNonmemberRegionError, Options<SaveWelloNonmemberRegionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveWelloNonmemberRegion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 웰로 디바이스 정보 저장
 */
export const saveAllowsWelloDeviceInfoMutation = (options?: Partial<Options<SaveAllowsWelloDeviceInfoData>>): UseMutationOptions<SaveAllowsWelloDeviceInfoResponse, SaveAllowsWelloDeviceInfoError, Options<SaveAllowsWelloDeviceInfoData>> => {
    const mutationOptions: UseMutationOptions<SaveAllowsWelloDeviceInfoResponse, SaveAllowsWelloDeviceInfoError, Options<SaveAllowsWelloDeviceInfoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveAllowsWelloDeviceInfo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 웰로 앱 푸시 트래킹&읽음 처리
 */
export const updateWelloAppPushRead1Mutation = (options?: Partial<Options<UpdateWelloAppPushRead1Data>>): UseMutationOptions<UpdateWelloAppPushRead1Response, UpdateWelloAppPushRead1Error, Options<UpdateWelloAppPushRead1Data>> => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushRead1Response, UpdateWelloAppPushRead1Error, Options<UpdateWelloAppPushRead1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWelloAppPushRead1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 웰로 앱 푸시(외부) 요청
 */
export const sendExtAppPushMutation = (options?: Partial<Options<SendExtAppPushData>>): UseMutationOptions<SendExtAppPushResponse, SendExtAppPushError, Options<SendExtAppPushData>> => {
    const mutationOptions: UseMutationOptions<SendExtAppPushResponse, SendExtAppPushError, Options<SendExtAppPushData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendExtAppPush({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 상품 상세 조회 피드백(조회수 증가)
 */
export const feedbackPointMarketProductMutation = (options?: Partial<Options<FeedbackPointMarketProductData>>): UseMutationOptions<FeedbackPointMarketProductResponse, FeedbackPointMarketProductError, Options<FeedbackPointMarketProductData>> => {
    const mutationOptions: UseMutationOptions<FeedbackPointMarketProductResponse, FeedbackPointMarketProductError, Options<FeedbackPointMarketProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await feedbackPointMarketProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 공통코드 초기화
 *
 * 공통코드가 추가된 경우 초기화 합니다
 */
export const commonCodeInitMutation = (options?: Partial<Options<CommonCodeInitData>>): UseMutationOptions<CommonCodeInitResponse, CommonCodeInitError, Options<CommonCodeInitData>> => {
    const mutationOptions: UseMutationOptions<CommonCodeInitResponse, CommonCodeInitError, Options<CommonCodeInitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commonCodeInit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const loginWelloSnsMemberMutation = (options?: Partial<Options<LoginWelloSnsMemberData>>): UseMutationOptions<LoginWelloSnsMemberResponse, LoginWelloSnsMemberError, Options<LoginWelloSnsMemberData>> => {
    const mutationOptions: UseMutationOptions<LoginWelloSnsMemberResponse, LoginWelloSnsMemberError, Options<LoginWelloSnsMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWelloSnsMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const welloBeforeLoginMutation = (options?: Partial<Options<WelloBeforeLoginData>>): UseMutationOptions<WelloBeforeLoginResponse, WelloBeforeLoginError, Options<WelloBeforeLoginData>> => {
    const mutationOptions: UseMutationOptions<WelloBeforeLoginResponse, WelloBeforeLoginError, Options<WelloBeforeLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await welloBeforeLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 앱 로그인 요청결과 저장
 */
export const saveLoginResultMutation = (options?: Partial<Options<SaveLoginResultData>>): UseMutationOptions<SaveLoginResultResponse, SaveLoginResultError, Options<SaveLoginResultData>> => {
    const mutationOptions: UseMutationOptions<SaveLoginResultResponse, SaveLoginResultError, Options<SaveLoginResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveLoginResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * NicePay 인증 결과 수신 (returnUrl)
 *
 * NicePay 인증 결과 수신 및 결제 승인 처리.
 *
 * <p>Content-Type: application/x-www-form-urlencoded
 * NicePay가 POST로 전송하는 파라미터를 @RequestParam으로 수신한다.
 * 처리 후 프론트엔드 성공/실패 페이지로 302 redirect한다.</p>
 */
export const handleAuthResultMutation = (options?: Partial<Options<HandleAuthResultData>>): UseMutationOptions<unknown, HandleAuthResultError, Options<HandleAuthResultData>> => {
    const mutationOptions: UseMutationOptions<unknown, HandleAuthResultError, Options<HandleAuthResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleAuthResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 이벤트 참여 요청
 */
export const joinEventMutation = (options?: Partial<Options<JoinEventData>>): UseMutationOptions<JoinEventResponse, JoinEventError, Options<JoinEventData>> => {
    const mutationOptions: UseMutationOptions<JoinEventResponse, JoinEventError, Options<JoinEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await joinEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * KB PAY 회원 웰로 로그인
 *
 * DomainRestrictionFilter에서 api 사용중으로 url 변경시 함께 변경 되어야 합니다.
 */
export const loginWelloWithKbPayMutation = (options?: Partial<Options<LoginWelloWithKbPayData>>): UseMutationOptions<LoginWelloWithKbPayResponse, LoginWelloWithKbPayError, Options<LoginWelloWithKbPayData>> => {
    const mutationOptions: UseMutationOptions<LoginWelloWithKbPayResponse, LoginWelloWithKbPayError, Options<LoginWelloWithKbPayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWelloWithKbPay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 특정 답례품 목록
 */
export const getGiftProductListMutation = (options?: Partial<Options<GetGiftProductListData>>): UseMutationOptions<GetGiftProductListResponse, GetGiftProductListError, Options<GetGiftProductListData>> => {
    const mutationOptions: UseMutationOptions<GetGiftProductListResponse, GetGiftProductListError, Options<GetGiftProductListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getGiftProductList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 고향사랑 컨텐츠 조회수 증가
 */
export const viewHomeGiftProductMutation = (options?: Partial<Options<ViewHomeGiftProductData>>): UseMutationOptions<ViewHomeGiftProductResponse, ViewHomeGiftProductError, Options<ViewHomeGiftProductData>> => {
    const mutationOptions: UseMutationOptions<ViewHomeGiftProductResponse, ViewHomeGiftProductError, Options<ViewHomeGiftProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await viewHomeGiftProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 피드 목록 조회
 *
 * 6개 소스의 컨텐츠를 혼합하여 피드 목록을 조회합니다
 */
export const findFeedsMutation = (options?: Partial<Options<FindFeedsData>>): UseMutationOptions<FindFeedsResponse, FindFeedsError, Options<FindFeedsData>> => {
    const mutationOptions: UseMutationOptions<FindFeedsResponse, FindFeedsError, Options<FindFeedsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await findFeeds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * NICE Pay 웹훅 수신
 *
 * NICE Pay 웹훅을 처리합니다.
 */
export const handleNicePayWebhookMutation = (options?: Partial<Options<HandleNicePayWebhookData>>): UseMutationOptions<HandleNicePayWebhookResponse, HandleNicePayWebhookError, Options<HandleNicePayWebhookData>> => {
    const mutationOptions: UseMutationOptions<HandleNicePayWebhookResponse, HandleNicePayWebhookError, Options<HandleNicePayWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleNicePayWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 인증 번호 확인
 *
 * 인증 번호 확인
 */
export const certificationCheckMutation = (options?: Partial<Options<CertificationCheckData>>): UseMutationOptions<CertificationCheckResponse, CertificationCheckError, Options<CertificationCheckData>> => {
    const mutationOptions: UseMutationOptions<CertificationCheckResponse, CertificationCheckError, Options<CertificationCheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await certificationCheck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 휴대전화번호 인증 발송
 *
 * 휴대전화번호 인증 발송
 */
export const sendCertificationCellphoneMutation = (options?: Partial<Options<SendCertificationCellphoneData>>): UseMutationOptions<SendCertificationCellphoneResponse, SendCertificationCellphoneError, Options<SendCertificationCellphoneData>> => {
    const mutationOptions: UseMutationOptions<SendCertificationCellphoneResponse, SendCertificationCellphoneError, Options<SendCertificationCellphoneData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendCertificationCellphone({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 블록리스트 초기화
 *
 * 블록리스트 추가된 경우 초기화 합니다
 */
export const commonCodeInit1Mutation = (options?: Partial<Options<CommonCodeInit1Data>>): UseMutationOptions<CommonCodeInit1Response, CommonCodeInit1Error, Options<CommonCodeInit1Data>> => {
    const mutationOptions: UseMutationOptions<CommonCodeInit1Response, CommonCodeInit1Error, Options<CommonCodeInit1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commonCodeInit1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * API 도입 문의 작성
 */
export const createApiCounselMutation = (options?: Partial<Options<CreateApiCounselData>>): UseMutationOptions<CreateApiCounselResponse, CreateApiCounselError, Options<CreateApiCounselData>> => {
    const mutationOptions: UseMutationOptions<CreateApiCounselResponse, CreateApiCounselError, Options<CreateApiCounselData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiCounsel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWelloQuickMenuListQueryKey = (options?: Options<GetWelloQuickMenuListData>) => createQueryKey('getWelloQuickMenuList', options);

/**
 * 웰로 퀵 메뉴 목록 조회
 *
 * 웰로 메인 상단 퀵 메뉴 목록을 조회합니다
 */
export const getWelloQuickMenuListOptions = (options?: Options<GetWelloQuickMenuListData>) => queryOptions<GetWelloQuickMenuListResponse, GetWelloQuickMenuListError, GetWelloQuickMenuListResponse, ReturnType<typeof getWelloQuickMenuListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWelloQuickMenuList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWelloQuickMenuListQueryKey(options)
});

export const welloPolicyCodeListQueryKey = (options: Options<WelloPolicyCodeListData>) => createQueryKey('welloPolicyCodeList', options);

/**
 * 웰로 정책 코드 목록
 */
export const welloPolicyCodeListOptions = (options: Options<WelloPolicyCodeListData>) => queryOptions<WelloPolicyCodeListResponse, WelloPolicyCodeListError, WelloPolicyCodeListResponse, ReturnType<typeof welloPolicyCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPolicyCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPolicyCodeListQueryKey(options)
});

export const reverseGeocodingQueryKey = (options: Options<ReverseGeocodingData>) => createQueryKey('reverseGeocoding', options);

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const reverseGeocodingOptions = (options: Options<ReverseGeocodingData>) => queryOptions<ReverseGeocodingResponse2, ReverseGeocodingError, ReverseGeocodingResponse2, ReturnType<typeof reverseGeocodingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await reverseGeocoding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: reverseGeocodingQueryKey(options)
});

export const kbWelloPolicyCodeAllListQueryKey = (options?: Options<KbWelloPolicyCodeAllListData>) => createQueryKey('kbWelloPolicyCodeAllList', options);

/**
 * KB 정책 코드 목록
 */
export const kbWelloPolicyCodeAllListOptions = (options?: Options<KbWelloPolicyCodeAllListData>) => queryOptions<KbWelloPolicyCodeAllListResponse, KbWelloPolicyCodeAllListError, KbWelloPolicyCodeAllListResponse, ReturnType<typeof kbWelloPolicyCodeAllListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kbWelloPolicyCodeAllList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kbWelloPolicyCodeAllListQueryKey(options)
});

export const geolocationQueryKey = (options: Options<GeolocationData>) => createQueryKey('geolocation', options);

/**
 * IP로 현재 위치의 지역정보 조회
 */
export const geolocationOptions = (options: Options<GeolocationData>) => queryOptions<GeolocationResponse, GeolocationError, GeolocationResponse, ReturnType<typeof geolocationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await geolocation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: geolocationQueryKey(options)
});

export const welloPolicyCodeBabyListQueryKey = (options?: Options<WelloPolicyCodeBabyListData>) => createQueryKey('welloPolicyCodeBabyList', options);

/**
 * 웰로 정책 코드 육아생활 목록
 */
export const welloPolicyCodeBabyListOptions = (options?: Options<WelloPolicyCodeBabyListData>) => queryOptions<WelloPolicyCodeBabyListResponse, WelloPolicyCodeBabyListError, WelloPolicyCodeBabyListResponse, ReturnType<typeof welloPolicyCodeBabyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPolicyCodeBabyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPolicyCodeBabyListQueryKey(options)
});

export const welloPolicyCodeAllListQueryKey = (options?: Options<WelloPolicyCodeAllListData>) => createQueryKey('welloPolicyCodeAllList', options);

/**
 * 웰로 정책 코드 전체 목록
 */
export const welloPolicyCodeAllListOptions = (options?: Options<WelloPolicyCodeAllListData>) => queryOptions<WelloPolicyCodeAllListResponse, WelloPolicyCodeAllListError, WelloPolicyCodeAllListResponse, ReturnType<typeof welloPolicyCodeAllListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPolicyCodeAllList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPolicyCodeAllListQueryKey(options)
});

export const detailWelloLandingQueryKey = (options?: Options<DetailWelloLandingData>) => createQueryKey('detailWelloLanding', options);

/**
 * 웰로 랜딩페이지 데이터 조회
 */
export const detailWelloLandingOptions = (options?: Options<DetailWelloLandingData>) => queryOptions<DetailWelloLandingResponse2, DetailWelloLandingError, DetailWelloLandingResponse2, ReturnType<typeof detailWelloLandingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await detailWelloLanding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: detailWelloLandingQueryKey(options)
});

export const getMetaPolicyCommentListQueryKey = (options: Options<GetMetaPolicyCommentListData>) => createQueryKey('getMetaPolicyCommentList', options);

/**
 * 댓글 목록 조회
 */
export const getMetaPolicyCommentListOptions = (options: Options<GetMetaPolicyCommentListData>) => queryOptions<GetMetaPolicyCommentListResponse, GetMetaPolicyCommentListError, GetMetaPolicyCommentListResponse, ReturnType<typeof getMetaPolicyCommentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetaPolicyCommentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetaPolicyCommentListQueryKey(options)
});

export const getMetaPolicyCommentListInfiniteQueryKey = (options: Options<GetMetaPolicyCommentListData>): QueryKey<Options<GetMetaPolicyCommentListData>> => createQueryKey('getMetaPolicyCommentList', options, true);

/**
 * 댓글 목록 조회
 */
export const getMetaPolicyCommentListInfiniteOptions = (options: Options<GetMetaPolicyCommentListData>) => infiniteQueryOptions<GetMetaPolicyCommentListResponse, GetMetaPolicyCommentListError, InfiniteData<GetMetaPolicyCommentListResponse>, QueryKey<Options<GetMetaPolicyCommentListData>>, number | Pick<QueryKey<Options<GetMetaPolicyCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetMetaPolicyCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getMetaPolicyCommentList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetaPolicyCommentListInfiniteQueryKey(options)
});

export const getMetaPolicyCommentList1QueryKey = (options: Options<GetMetaPolicyCommentList1Data>) => createQueryKey('getMetaPolicyCommentList1', options);

/**
 * 댓글 상세 조회
 */
export const getMetaPolicyCommentList1Options = (options: Options<GetMetaPolicyCommentList1Data>) => queryOptions<GetMetaPolicyCommentList1Response, GetMetaPolicyCommentList1Error, GetMetaPolicyCommentList1Response, ReturnType<typeof getMetaPolicyCommentList1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetaPolicyCommentList1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetaPolicyCommentList1QueryKey(options)
});

export const getLiveWelloCommentListQueryKey = (options?: Options<GetLiveWelloCommentListData>) => createQueryKey('getLiveWelloCommentList', options);

/**
 * 웰로 실시간 정책 의견
 *
 * @deprecated
 */
export const getLiveWelloCommentListOptions = (options?: Options<GetLiveWelloCommentListData>) => queryOptions<GetLiveWelloCommentListResponse, GetLiveWelloCommentListError, GetLiveWelloCommentListResponse, ReturnType<typeof getLiveWelloCommentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLiveWelloCommentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLiveWelloCommentListQueryKey(options)
});

export const newWelloAppPushCntQueryKey = (options: Options<NewWelloAppPushCntData>) => createQueryKey('newWelloAppPushCnt', options);

/**
 * 웰로 앱 푸시 알림 건수 조회
 */
export const newWelloAppPushCntOptions = (options: Options<NewWelloAppPushCntData>) => queryOptions<NewWelloAppPushCntResponse, NewWelloAppPushCntError, NewWelloAppPushCntResponse, ReturnType<typeof newWelloAppPushCntQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await newWelloAppPushCnt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: newWelloAppPushCntQueryKey(options)
});

export const getWelcomeMonitorDisplayListQueryKey = (options: Options<GetWelcomeMonitorDisplayListData>) => createQueryKey('getWelcomeMonitorDisplayList', options);

/**
 * 웰컴 모니터 노출 대상 조회
 */
export const getWelcomeMonitorDisplayListOptions = (options: Options<GetWelcomeMonitorDisplayListData>) => queryOptions<GetWelcomeMonitorDisplayListResponse, GetWelcomeMonitorDisplayListError, GetWelcomeMonitorDisplayListResponse, ReturnType<typeof getWelcomeMonitorDisplayListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWelcomeMonitorDisplayList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWelcomeMonitorDisplayListQueryKey(options)
});

export const getUrlMappingQueryKey = (options: Options<GetUrlMappingData>) => createQueryKey('getUrlMapping', options);

/**
 * URL 매핑 상세 조회
 *
 * URL 매핑 상세 조회
 */
export const getUrlMappingOptions = (options: Options<GetUrlMappingData>) => queryOptions<GetUrlMappingResponse, GetUrlMappingError, GetUrlMappingResponse, ReturnType<typeof getUrlMappingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUrlMapping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUrlMappingQueryKey(options)
});

export const findTourDistanceQueryKey = (options: Options<FindTourDistanceData>) => createQueryKey('findTourDistance', options);

/**
 * 투어 거리 조회 (비로그인 허용)
 *
 * subRegionCode 중심 좌표로부터 투어 point 까지의 거리(미터)를 계산한다. 중심 좌표 미존재 시 30404, 좌표 손상 시 30400, 투어 미존재/비공개 시 30404. point 없으면 distance=null.
 */
export const findTourDistanceOptions = (options: Options<FindTourDistanceData>) => queryOptions<FindTourDistanceResponse, FindTourDistanceError, FindTourDistanceResponse, ReturnType<typeof findTourDistanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourDistance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourDistanceQueryKey(options)
});

export const findTourFeedbackQueryKey = (options: Options<FindTourFeedbackData>) => createQueryKey('findTourFeedback', options);

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * Tour 의 조회수/스크랩 정보를 조회한다.
 */
export const findTourFeedbackOptions = (options: Options<FindTourFeedbackData>) => queryOptions<FindTourFeedbackResponse, FindTourFeedbackError, FindTourFeedbackResponse, ReturnType<typeof findTourFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFeedbackQueryKey(options)
});

export const termQueryKey = (options: Options<TermData>) => createQueryKey('term', options);

/**
 * 약관을 조회합니다.
 *
 * 약관 조회
 */
export const termOptions = (options: Options<TermData>) => queryOptions<TermResponse, TermError, TermResponse, ReturnType<typeof termQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await term({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termQueryKey(options)
});

export const fileDecryptionDownloadQueryKey = (options: Options<FileDecryptionDownloadData>) => createQueryKey('fileDecryptionDownload', options);

/**
 * 비회원 파일 복호화 다운로드
 */
export const fileDecryptionDownloadOptions = (options: Options<FileDecryptionDownloadData>) => queryOptions<FileDecryptionDownloadResponse, FileDecryptionDownloadError, FileDecryptionDownloadResponse, ReturnType<typeof fileDecryptionDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fileDecryptionDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fileDecryptionDownloadQueryKey(options)
});

export const findTourFestivalsQueryKey = (options: Options<FindTourFestivalsData>) => createQueryKey('findTourFestivals', options);

/**
 * 축제 위치 기반 목록
 *
 * subRegionCode 좌표 기준 radius(미터) 내 축제를 거리 ASC로 정렬해 반환한다. 응답은 distance(미터)를 포함한다.
 */
export const findTourFestivalsOptions = (options: Options<FindTourFestivalsData>) => queryOptions<FindTourFestivalsResponse, FindTourFestivalsError, FindTourFestivalsResponse, ReturnType<typeof findTourFestivalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourFestivals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFestivalsQueryKey(options)
});

export const findTourFestivalsInfiniteQueryKey = (options: Options<FindTourFestivalsData>): QueryKey<Options<FindTourFestivalsData>> => createQueryKey('findTourFestivals', options, true);

/**
 * 축제 위치 기반 목록
 *
 * subRegionCode 좌표 기준 radius(미터) 내 축제를 거리 ASC로 정렬해 반환한다. 응답은 distance(미터)를 포함한다.
 */
export const findTourFestivalsInfiniteOptions = (options: Options<FindTourFestivalsData>) => infiniteQueryOptions<FindTourFestivalsResponse, FindTourFestivalsError, InfiniteData<FindTourFestivalsResponse>, QueryKey<Options<FindTourFestivalsData>>, number | Pick<QueryKey<Options<FindTourFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindTourFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findTourFestivals({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFestivalsInfiniteQueryKey(options)
});

export const findPoliciesQueryKey = (options?: Options<FindPoliciesData>) => createQueryKey('findPolicies', options);

/**
 * 정책 검색
 */
export const findPoliciesOptions = (options?: Options<FindPoliciesData>) => queryOptions<FindPoliciesResponse, FindPoliciesError, FindPoliciesResponse, ReturnType<typeof findPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPoliciesQueryKey(options)
});

export const findPoliciesInfiniteQueryKey = (options?: Options<FindPoliciesData>): QueryKey<Options<FindPoliciesData>> => createQueryKey('findPolicies', options, true);

/**
 * 정책 검색
 */
export const findPoliciesInfiniteOptions = (options?: Options<FindPoliciesData>) => infiniteQueryOptions<FindPoliciesResponse, FindPoliciesError, InfiniteData<FindPoliciesResponse>, QueryKey<Options<FindPoliciesData>>, number | Pick<QueryKey<Options<FindPoliciesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindPoliciesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findPolicies({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPoliciesInfiniteQueryKey(options)
});

export const findQueryTargetCodeQueryKey = (options?: Options<FindQueryTargetCodeData>) => createQueryKey('findQueryTargetCode', options);

/**
 * 정책 검색 - 대상
 */
export const findQueryTargetCodeOptions = (options?: Options<FindQueryTargetCodeData>) => queryOptions<FindQueryTargetCodeResponse, FindQueryTargetCodeError, FindQueryTargetCodeResponse, ReturnType<typeof findQueryTargetCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryTargetCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryTargetCodeQueryKey(options)
});

export const findQueryProvisionCodeQueryKey = (options?: Options<FindQueryProvisionCodeData>) => createQueryKey('findQueryProvisionCode', options);

/**
 * 정책 검색, 정책 활용 가이드 - 지원형태
 */
export const findQueryProvisionCodeOptions = (options?: Options<FindQueryProvisionCodeData>) => queryOptions<FindQueryProvisionCodeResponse, FindQueryProvisionCodeError, FindQueryProvisionCodeResponse, ReturnType<typeof findQueryProvisionCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryProvisionCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryProvisionCodeQueryKey(options)
});

export const findQueryJobCodeQueryKey = (options?: Options<FindQueryJobCodeData>) => createQueryKey('findQueryJobCode', options);

/**
 * 정책 검색 - 직업
 */
export const findQueryJobCodeOptions = (options?: Options<FindQueryJobCodeData>) => queryOptions<FindQueryJobCodeResponse, FindQueryJobCodeError, FindQueryJobCodeResponse, ReturnType<typeof findQueryJobCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryJobCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryJobCodeQueryKey(options)
});

export const findQueryAgeCodeQueryKey = (options?: Options<FindQueryAgeCodeData>) => createQueryKey('findQueryAgeCode', options);

/**
 * 정책 검색 - 연령
 */
export const findQueryAgeCodeOptions = (options?: Options<FindQueryAgeCodeData>) => queryOptions<FindQueryAgeCodeResponse, FindQueryAgeCodeError, FindQueryAgeCodeResponse, ReturnType<typeof findQueryAgeCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryAgeCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryAgeCodeQueryKey(options)
});

export const findLocalMarketProductsQueryKey = (options?: Options<FindLocalMarketProductsData>) => createQueryKey('findLocalMarketProducts', options);

/**
 * 웰마켓 검색
 */
export const findLocalMarketProductsOptions = (options?: Options<FindLocalMarketProductsData>) => queryOptions<FindLocalMarketProductsResponse, FindLocalMarketProductsError, FindLocalMarketProductsResponse, ReturnType<typeof findLocalMarketProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findLocalMarketProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findLocalMarketProductsQueryKey(options)
});

export const findLocalMarketProductsInfiniteQueryKey = (options?: Options<FindLocalMarketProductsData>): QueryKey<Options<FindLocalMarketProductsData>> => createQueryKey('findLocalMarketProducts', options, true);

/**
 * 웰마켓 검색
 */
export const findLocalMarketProductsInfiniteOptions = (options?: Options<FindLocalMarketProductsData>) => infiniteQueryOptions<FindLocalMarketProductsResponse, FindLocalMarketProductsError, InfiniteData<FindLocalMarketProductsResponse>, QueryKey<Options<FindLocalMarketProductsData>>, number | Pick<QueryKey<Options<FindLocalMarketProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindLocalMarketProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findLocalMarketProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findLocalMarketProductsInfiniteQueryKey(options)
});

export const findHometownNewsQueryKey = (options?: Options<FindHometownNewsData>) => createQueryKey('findHometownNews', options);

/**
 * 동네소식 검색
 */
export const findHometownNewsOptions = (options?: Options<FindHometownNewsData>) => queryOptions<FindHometownNewsResponse, FindHometownNewsError, FindHometownNewsResponse, ReturnType<typeof findHometownNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findHometownNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findHometownNewsQueryKey(options)
});

export const findHometownNewsInfiniteQueryKey = (options?: Options<FindHometownNewsData>): QueryKey<Options<FindHometownNewsData>> => createQueryKey('findHometownNews', options, true);

/**
 * 동네소식 검색
 */
export const findHometownNewsInfiniteOptions = (options?: Options<FindHometownNewsData>) => infiniteQueryOptions<FindHometownNewsResponse, FindHometownNewsError, InfiniteData<FindHometownNewsResponse>, QueryKey<Options<FindHometownNewsData>>, number | Pick<QueryKey<Options<FindHometownNewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindHometownNewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findHometownNews({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findHometownNewsInfiniteQueryKey(options)
});

export const findGiftProductsQueryKey = (options?: Options<FindGiftProductsData>) => createQueryKey('findGiftProducts', options);

/**
 * 답례품 검색
 */
export const findGiftProductsOptions = (options?: Options<FindGiftProductsData>) => queryOptions<FindGiftProductsResponse, FindGiftProductsError, FindGiftProductsResponse, ReturnType<typeof findGiftProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftProductsQueryKey(options)
});

export const findGiftProductsInfiniteQueryKey = (options?: Options<FindGiftProductsData>): QueryKey<Options<FindGiftProductsData>> => createQueryKey('findGiftProducts', options, true);

/**
 * 답례품 검색
 */
export const findGiftProductsInfiniteOptions = (options?: Options<FindGiftProductsData>) => infiniteQueryOptions<FindGiftProductsResponse, FindGiftProductsError, InfiniteData<FindGiftProductsResponse>, QueryKey<Options<FindGiftProductsData>>, number | Pick<QueryKey<Options<FindGiftProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindGiftProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findGiftProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftProductsInfiniteQueryKey(options)
});

export const findDonationBusinessesQueryKey = (options?: Options<FindDonationBusinessesData>) => createQueryKey('findDonationBusinesses', options);

/**
 * 지정기부사업 검색
 */
export const findDonationBusinessesOptions = (options?: Options<FindDonationBusinessesData>) => queryOptions<FindDonationBusinessesResponse, FindDonationBusinessesError, FindDonationBusinessesResponse, ReturnType<typeof findDonationBusinessesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findDonationBusinesses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findDonationBusinessesQueryKey(options)
});

export const findDonationBusinessesInfiniteQueryKey = (options?: Options<FindDonationBusinessesData>): QueryKey<Options<FindDonationBusinessesData>> => createQueryKey('findDonationBusinesses', options, true);

/**
 * 지정기부사업 검색
 */
export const findDonationBusinessesInfiniteOptions = (options?: Options<FindDonationBusinessesData>) => infiniteQueryOptions<FindDonationBusinessesResponse, FindDonationBusinessesError, InfiniteData<FindDonationBusinessesResponse>, QueryKey<Options<FindDonationBusinessesData>>, number | Pick<QueryKey<Options<FindDonationBusinessesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindDonationBusinessesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findDonationBusinesses({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findDonationBusinessesInfiniteQueryKey(options)
});

export const findBestContentsQueryKey = (options: Options<FindBestContentsData>) => createQueryKey('findBestContents', options);

/**
 * 정책소식 검색
 */
export const findBestContentsOptions = (options: Options<FindBestContentsData>) => queryOptions<FindBestContentsResponse, FindBestContentsError, FindBestContentsResponse, ReturnType<typeof findBestContentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findBestContents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findBestContentsQueryKey(options)
});

export const findBestContentsInfiniteQueryKey = (options: Options<FindBestContentsData>): QueryKey<Options<FindBestContentsData>> => createQueryKey('findBestContents', options, true);

/**
 * 정책소식 검색
 */
export const findBestContentsInfiniteOptions = (options: Options<FindBestContentsData>) => infiniteQueryOptions<FindBestContentsResponse, FindBestContentsError, InfiniteData<FindBestContentsResponse>, QueryKey<Options<FindBestContentsData>>, number | Pick<QueryKey<Options<FindBestContentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindBestContentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findBestContents({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findBestContentsInfiniteQueryKey(options)
});

export const metaPolicyQueryKey = (options: Options<MetaPolicyData>) => createQueryKey('metaPolicy', options);

/**
 * 비회원 정책 상세 조회
 */
export const metaPolicyOptions = (options: Options<MetaPolicyData>) => queryOptions<MetaPolicyResponse, MetaPolicyError, MetaPolicyResponse, ReturnType<typeof metaPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaPolicyQueryKey(options)
});

export const popularPolicyListQueryKey = (options?: Options<PopularPolicyListData>) => createQueryKey('popularPolicyList', options);

/**
 * 비회원 인기정책 조회
 */
export const popularPolicyListOptions = (options?: Options<PopularPolicyListData>) => queryOptions<PopularPolicyListResponse, PopularPolicyListError, PopularPolicyListResponse, ReturnType<typeof popularPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await popularPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: popularPolicyListQueryKey(options)
});

export const metaPolicyFeedbackQueryKey = (options: Options<MetaPolicyFeedbackData>) => createQueryKey('metaPolicyFeedback', options);

/**
 * 비로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const metaPolicyFeedbackOptions = (options: Options<MetaPolicyFeedbackData>) => queryOptions<MetaPolicyFeedbackResponse, MetaPolicyFeedbackError, MetaPolicyFeedbackResponse, ReturnType<typeof metaPolicyFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaPolicyFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaPolicyFeedbackQueryKey(options)
});

export const getPolicyDictionaryListQueryKey = (options?: Options<GetPolicyDictionaryListData>) => createQueryKey('getPolicyDictionaryList', options);

/**
 * 정책 사전 목록 조회
 */
export const getPolicyDictionaryListOptions = (options?: Options<GetPolicyDictionaryListData>) => queryOptions<GetPolicyDictionaryListResponse, GetPolicyDictionaryListError, GetPolicyDictionaryListResponse, ReturnType<typeof getPolicyDictionaryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPolicyDictionaryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPolicyDictionaryListQueryKey(options)
});

export const getPolicyCodeGeocodingListQueryKey = (options?: Options<GetPolicyCodeGeocodingListData>) => createQueryKey('getPolicyCodeGeocodingList', options);

/**
 * 지역 좌표 목록 조회
 */
export const getPolicyCodeGeocodingListOptions = (options?: Options<GetPolicyCodeGeocodingListData>) => queryOptions<GetPolicyCodeGeocodingListResponse, GetPolicyCodeGeocodingListError, GetPolicyCodeGeocodingListResponse, ReturnType<typeof getPolicyCodeGeocodingListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPolicyCodeGeocodingList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPolicyCodeGeocodingListQueryKey(options)
});

export const getListPolicyCaseCategoryQueryKey = (options?: Options<GetListPolicyCaseCategoryData>) => createQueryKey('getListPolicyCaseCategory', options);

/**
 * 내 상황에 맞는 정책 카테고리
 */
export const getListPolicyCaseCategoryOptions = (options?: Options<GetListPolicyCaseCategoryData>) => queryOptions<GetListPolicyCaseCategoryResponse, GetListPolicyCaseCategoryError, GetListPolicyCaseCategoryResponse, ReturnType<typeof getListPolicyCaseCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getListPolicyCaseCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getListPolicyCaseCategoryQueryKey(options)
});

export const getListChildcarePolicyBudgetQueryKey = (options: Options<GetListChildcarePolicyBudgetData>) => createQueryKey('getListChildcarePolicyBudget', options);

/**
 * 내 상황에 맞는 육아 정책 조회
 */
export const getListChildcarePolicyBudgetOptions = (options: Options<GetListChildcarePolicyBudgetData>) => queryOptions<GetListChildcarePolicyBudgetResponse, GetListChildcarePolicyBudgetError, GetListChildcarePolicyBudgetResponse, ReturnType<typeof getListChildcarePolicyBudgetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getListChildcarePolicyBudget({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getListChildcarePolicyBudgetQueryKey(options)
});

export const getListChildcareRelatedPolicyQueryKey = (options: Options<GetListChildcareRelatedPolicyData>) => createQueryKey('getListChildcareRelatedPolicy', options);

/**
 * 내 상황에 맞는 육아 정책 관련 정책 조회
 */
export const getListChildcareRelatedPolicyOptions = (options: Options<GetListChildcareRelatedPolicyData>) => queryOptions<GetListChildcareRelatedPolicyResponse, GetListChildcareRelatedPolicyError, GetListChildcareRelatedPolicyResponse, ReturnType<typeof getListChildcareRelatedPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getListChildcareRelatedPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getListChildcareRelatedPolicyQueryKey(options)
});

export const getHomeWelloPolicyApplyListQueryKey = (options: Options<GetHomeWelloPolicyApplyListData>) => createQueryKey('getHomeWelloPolicyApplyList', options);

/**
 * 홈 - 정책 바로신청 조회
 */
export const getHomeWelloPolicyApplyListOptions = (options: Options<GetHomeWelloPolicyApplyListData>) => queryOptions<GetHomeWelloPolicyApplyListResponse, GetHomeWelloPolicyApplyListError, GetHomeWelloPolicyApplyListResponse, ReturnType<typeof getHomeWelloPolicyApplyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeWelloPolicyApplyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeWelloPolicyApplyListQueryKey(options)
});

export const getPointInfoQueryKey = (options: Options<GetPointInfoData>) => createQueryKey('getPointInfo', options);

/**
 * 타입별 포인트 조회
 *
 * 타입별 포인트 적립/사용 정보 조회
 */
export const getPointInfoOptions = (options: Options<GetPointInfoData>) => queryOptions<GetPointInfoResponse, GetPointInfoError, GetPointInfoResponse, ReturnType<typeof getPointInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointInfoQueryKey(options)
});

export const getPointEarningQueryKey = (options?: Options<GetPointEarningData>) => createQueryKey('getPointEarning', options);

/**
 * 포인트 획득 조회
 *
 * 유저 액션 별 획득 가능 포인트를 조회합니다.
 */
export const getPointEarningOptions = (options?: Options<GetPointEarningData>) => queryOptions<GetPointEarningResponse, GetPointEarningError, GetPointEarningResponse, ReturnType<typeof getPointEarningQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointEarning({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointEarningQueryKey(options)
});

export const getPointBudgetQueryKey = (options?: Options<GetPointBudgetData>) => createQueryKey('getPointBudget', options);

/**
 * 예산 포인트 정보 조회
 *
 * 포인트 잔액, 출금 가능 포인트를 조회합니다.
 */
export const getPointBudgetOptions = (options?: Options<GetPointBudgetData>) => queryOptions<GetPointBudgetResponse, GetPointBudgetError, GetPointBudgetResponse, ReturnType<typeof getPointBudgetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointBudget({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointBudgetQueryKey(options)
});

export const getPointMarketProductListQueryKey = (options?: Options<GetPointMarketProductListData>) => createQueryKey('getPointMarketProductList', options);

/**
 * 상품 목록 조회
 */
export const getPointMarketProductListOptions = (options?: Options<GetPointMarketProductListData>) => queryOptions<GetPointMarketProductListResponse, GetPointMarketProductListError, GetPointMarketProductListResponse, ReturnType<typeof getPointMarketProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductListQueryKey(options)
});

export const getPointMarketProductListInfiniteQueryKey = (options?: Options<GetPointMarketProductListData>): QueryKey<Options<GetPointMarketProductListData>> => createQueryKey('getPointMarketProductList', options, true);

/**
 * 상품 목록 조회
 */
export const getPointMarketProductListInfiniteOptions = (options?: Options<GetPointMarketProductListData>) => infiniteQueryOptions<GetPointMarketProductListResponse, GetPointMarketProductListError, InfiniteData<GetPointMarketProductListResponse>, QueryKey<Options<GetPointMarketProductListData>>, number | Pick<QueryKey<Options<GetPointMarketProductListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetPointMarketProductListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPointMarketProductList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductListInfiniteQueryKey(options)
});

export const getPointMarketProductQueryKey = (options: Options<GetPointMarketProductData>) => createQueryKey('getPointMarketProduct', options);

/**
 * 상품 상세 조회(+ 지금 본 상품과 비슷한 상품 목록)
 */
export const getPointMarketProductOptions = (options: Options<GetPointMarketProductData>) => queryOptions<GetPointMarketProductResponse, GetPointMarketProductError, GetPointMarketProductResponse, ReturnType<typeof getPointMarketProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductQueryKey(options)
});

export const getPopularPointMarketProductListQueryKey = (options?: Options<GetPopularPointMarketProductListData>) => createQueryKey('getPopularPointMarketProductList', options);

/**
 * 인기 상품 목록 조회 (top 6)
 */
export const getPopularPointMarketProductListOptions = (options?: Options<GetPopularPointMarketProductListData>) => queryOptions<GetPopularPointMarketProductListResponse, GetPopularPointMarketProductListError, GetPopularPointMarketProductListResponse, ReturnType<typeof getPopularPointMarketProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPopularPointMarketProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPopularPointMarketProductListQueryKey(options)
});

export const getPointMarketProductListByBrandQueryKey = (options?: Options<GetPointMarketProductListByBrandData>) => createQueryKey('getPointMarketProductListByBrand', options);

/**
 * 브랜드별 상품 목록 조회 (페이징 없음)
 */
export const getPointMarketProductListByBrandOptions = (options?: Options<GetPointMarketProductListByBrandData>) => queryOptions<GetPointMarketProductListByBrandResponse, GetPointMarketProductListByBrandError, GetPointMarketProductListByBrandResponse, ReturnType<typeof getPointMarketProductListByBrandQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketProductListByBrand({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductListByBrandQueryKey(options)
});

export const getPointMarketBrandListQueryKey = (options?: Options<GetPointMarketBrandListData>) => createQueryKey('getPointMarketBrandList', options);

/**
 * 카테고리별 브랜드 목록 조회
 */
export const getPointMarketBrandListOptions = (options?: Options<GetPointMarketBrandListData>) => queryOptions<GetPointMarketBrandListResponse, GetPointMarketBrandListError, GetPointMarketBrandListResponse, ReturnType<typeof getPointMarketBrandListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketBrandList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketBrandListQueryKey(options)
});

export const getWelloPickBannerListQueryKey = (options?: Options<GetWelloPickBannerListData>) => createQueryKey('getWelloPickBannerList', options);

/**
 * 웰로픽! 요즘 뜨는 정책 목록 조회
 *
 * 웰로픽 - 메인 정책 큐레이션 목록을 조회합니다
 */
export const getWelloPickBannerListOptions = (options?: Options<GetWelloPickBannerListData>) => queryOptions<GetWelloPickBannerListResponse, GetWelloPickBannerListError, GetWelloPickBannerListResponse, ReturnType<typeof getWelloPickBannerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWelloPickBannerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWelloPickBannerListQueryKey(options)
});

export const getNonMemberSuggestPolicyListQueryKey = (options: Options<GetNonMemberSuggestPolicyListData>) => createQueryKey('getNonMemberSuggestPolicyList', options);

/**
 * 비회원 맞춤 정책 검색목록 조회
 */
export const getNonMemberSuggestPolicyListOptions = (options: Options<GetNonMemberSuggestPolicyListData>) => queryOptions<GetNonMemberSuggestPolicyListResponse, GetNonMemberSuggestPolicyListError, GetNonMemberSuggestPolicyListResponse, ReturnType<typeof getNonMemberSuggestPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNonMemberSuggestPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNonMemberSuggestPolicyListQueryKey(options)
});

export const checkPlusSuccessQueryKey = (options: Options<CheckPlusSuccessData>) => createQueryKey('checkPlusSuccess', options);

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const checkPlusSuccessOptions = (options: Options<CheckPlusSuccessData>) => queryOptions<CheckPlusSuccessResponse, CheckPlusSuccessError, CheckPlusSuccessResponse, ReturnType<typeof checkPlusSuccessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkPlusSuccess({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkPlusSuccessQueryKey(options)
});

export const metaCodeAllQueryKey = (options: Options<MetaCodeAllData>) => createQueryKey('metaCodeAll', options);

/**
 * 메타코드 정보 조회
 *
 * 메타코드 및 메타코드의 하위 코드까지 조회합니다
 */
export const metaCodeAllOptions = (options: Options<MetaCodeAllData>) => queryOptions<MetaCodeAllResponse2, MetaCodeAllError, MetaCodeAllResponse2, ReturnType<typeof metaCodeAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaCodeAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaCodeAllQueryKey(options)
});

export const noticeListQueryKey = (options?: Options<NoticeListData>) => createQueryKey('noticeList', options);

/**
 * 신규 닉네임 조회
 *
 * 신규 닉네임을 조회합니다
 */
export const noticeListOptions = (options?: Options<NoticeListData>) => queryOptions<NoticeListResponse, NoticeListError, NoticeListResponse, ReturnType<typeof noticeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await noticeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: noticeListQueryKey(options)
});

export const snsRefreshTokenQueryKey = (options: Options<SnsRefreshTokenData>) => createQueryKey('snsRefreshToken', options);

export const snsRefreshTokenOptions = (options: Options<SnsRefreshTokenData>) => queryOptions<SnsRefreshTokenResponse, SnsRefreshTokenError, SnsRefreshTokenResponse, ReturnType<typeof snsRefreshTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await snsRefreshToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: snsRefreshTokenQueryKey(options)
});

export const getKbMemberLoginTypeListQueryKey = (options: Options<GetKbMemberLoginTypeListData>) => createQueryKey('getKbMemberLoginTypeList', options);

export const getKbMemberLoginTypeListOptions = (options: Options<GetKbMemberLoginTypeListData>) => queryOptions<GetKbMemberLoginTypeListResponse, GetKbMemberLoginTypeListError, GetKbMemberLoginTypeListResponse, ReturnType<typeof getKbMemberLoginTypeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getKbMemberLoginTypeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKbMemberLoginTypeListQueryKey(options)
});

export const getMedianIncomeListQueryKey = (options?: Options<GetMedianIncomeListData>) => createQueryKey('getMedianIncomeList', options);

/**
 * 중위소득 조회
 */
export const getMedianIncomeListOptions = (options?: Options<GetMedianIncomeListData>) => queryOptions<GetMedianIncomeListResponse, GetMedianIncomeListError, GetMedianIncomeListResponse, ReturnType<typeof getMedianIncomeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedianIncomeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMedianIncomeListQueryKey(options)
});

export const getMaintenanceQueryKey = (options: Options<GetMaintenanceData>) => createQueryKey('getMaintenance', options);

/**
 * 특정 점검 상세 조회
 *
 * 특정 점검 상세 조회
 */
export const getMaintenanceOptions = (options: Options<GetMaintenanceData>) => queryOptions<GetMaintenanceResponse, GetMaintenanceError, GetMaintenanceResponse, ReturnType<typeof getMaintenanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaintenance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenanceQueryKey(options)
});

export const getActiveMaintenanceListQueryKey = (options?: Options<GetActiveMaintenanceListData>) => createQueryKey('getActiveMaintenanceList', options);

/**
 * 현재 활성화된 점검 목록 조회
 *
 * 현재 활성화된 점검 목록 조회
 */
export const getActiveMaintenanceListOptions = (options?: Options<GetActiveMaintenanceListData>) => queryOptions<GetActiveMaintenanceListResponse, GetActiveMaintenanceListError, GetActiveMaintenanceListResponse, ReturnType<typeof getActiveMaintenanceListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActiveMaintenanceList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActiveMaintenanceListQueryKey(options)
});

export const termHistoryQueryKey = (options: Options<TermHistoryData>) => createQueryKey('termHistory', options);

/**
 * 약관 변경 이력을 조회합니다.
 *
 * 약관 변경이력 조회
 */
export const termHistoryOptions = (options: Options<TermHistoryData>) => queryOptions<TermHistoryResponse, TermHistoryError, TermHistoryResponse, ReturnType<typeof termHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termHistoryQueryKey(options)
});

export const getProductDetailQueryKey = (options: Options<GetProductDetailData>) => createQueryKey('getProductDetail', options);

/**
 * 상품 상세 조회
 *
 * 상품 ID(UUID)로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>}</p>
 *
 * <p>Spring이 <code>@PathVariable UUID</code> 타입 변환 시 UUID 형식이 아니면 자동으로 400 에러를 반환한다.</p>
 */
export const getProductDetailOptions = (options: Options<GetProductDetailData>) => queryOptions<GetProductDetailResponse, GetProductDetailError, GetProductDetailResponse, ReturnType<typeof getProductDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductDetailQueryKey(options)
});

export const getProductSeoByProductIdQueryKey = (options: Options<GetProductSeoByProductIdData>) => createQueryKey('getProductSeoByProductId', options);

/**
 * 상품 ID로 SEO 정보 조회 (비인증)
 *
 * 상품 ID(UUID)로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>/seo}</p>
 */
export const getProductSeoByProductIdOptions = (options: Options<GetProductSeoByProductIdData>) => queryOptions<GetProductSeoByProductIdResponse, GetProductSeoByProductIdError, GetProductSeoByProductIdResponse, ReturnType<typeof getProductSeoByProductIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductSeoByProductId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductSeoByProductIdQueryKey(options)
});

export const findReviewsQueryKey = (options: Options<FindReviewsData>) => createQueryKey('findReviews', options);

/**
 * 상품 리뷰 목록 조회
 *
 * 상품 ID로 상품 리뷰 목록을 조회한다.
 */
export const findReviewsOptions = (options: Options<FindReviewsData>) => queryOptions<FindReviewsResponse, FindReviewsError, FindReviewsResponse, ReturnType<typeof findReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findReviewsQueryKey(options)
});

export const findReviewsInfiniteQueryKey = (options: Options<FindReviewsData>): QueryKey<Options<FindReviewsData>> => createQueryKey('findReviews', options, true);

/**
 * 상품 리뷰 목록 조회
 *
 * 상품 ID로 상품 리뷰 목록을 조회한다.
 */
export const findReviewsInfiniteOptions = (options: Options<FindReviewsData>) => infiniteQueryOptions<FindReviewsResponse, FindReviewsError, InfiniteData<FindReviewsResponse>, QueryKey<Options<FindReviewsData>>, number | Pick<QueryKey<Options<FindReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findReviews({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findReviewsInfiniteQueryKey(options)
});

export const findReviewQueryKey = (options: Options<FindReviewData>) => createQueryKey('findReview', options);

/**
 * 상품 리뷰 상세 조회
 *
 * 상품 리뷰 상세를 조회한다.
 */
export const findReviewOptions = (options: Options<FindReviewData>) => queryOptions<FindReviewResponse, FindReviewError, FindReviewResponse, ReturnType<typeof findReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findReviewQueryKey(options)
});

export const findPhotoReviewsQueryKey = (options: Options<FindPhotoReviewsData>) => createQueryKey('findPhotoReviews', options);

/**
 * 상품 포토 리뷰 목록 조회
 *
 * 상품 포토 리뷰 이미지 목록 조회
 */
export const findPhotoReviewsOptions = (options: Options<FindPhotoReviewsData>) => queryOptions<FindPhotoReviewsResponse, FindPhotoReviewsError, FindPhotoReviewsResponse, ReturnType<typeof findPhotoReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findPhotoReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPhotoReviewsQueryKey(options)
});

export const findPhotoReviewsInfiniteQueryKey = (options: Options<FindPhotoReviewsData>): QueryKey<Options<FindPhotoReviewsData>> => createQueryKey('findPhotoReviews', options, true);

/**
 * 상품 포토 리뷰 목록 조회
 *
 * 상품 포토 리뷰 이미지 목록 조회
 */
export const findPhotoReviewsInfiniteOptions = (options: Options<FindPhotoReviewsData>) => infiniteQueryOptions<FindPhotoReviewsResponse, FindPhotoReviewsError, InfiniteData<FindPhotoReviewsResponse>, QueryKey<Options<FindPhotoReviewsData>>, number | Pick<QueryKey<Options<FindPhotoReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindPhotoReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findPhotoReviews({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPhotoReviewsInfiniteQueryKey(options)
});

export const findAllInquiriesQueryKey = (options: Options<FindAllInquiriesData>) => createQueryKey('findAllInquiries', options);

/**
 * 상품 문의 목록 조회
 *
 * 상품 문의 목록 조회
 */
export const findAllInquiriesOptions = (options: Options<FindAllInquiriesData>) => queryOptions<FindAllInquiriesResponse, FindAllInquiriesError, FindAllInquiriesResponse, ReturnType<typeof findAllInquiriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findAllInquiries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findAllInquiriesQueryKey(options)
});

export const findAllInquiriesInfiniteQueryKey = (options: Options<FindAllInquiriesData>): QueryKey<Options<FindAllInquiriesData>> => createQueryKey('findAllInquiries', options, true);

/**
 * 상품 문의 목록 조회
 *
 * 상품 문의 목록 조회
 */
export const findAllInquiriesInfiniteOptions = (options: Options<FindAllInquiriesData>) => infiniteQueryOptions<FindAllInquiriesResponse, FindAllInquiriesError, InfiniteData<FindAllInquiriesResponse>, QueryKey<Options<FindAllInquiriesData>>, number | Pick<QueryKey<Options<FindAllInquiriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindAllInquiriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findAllInquiries({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findAllInquiriesInfiniteQueryKey(options)
});

export const findInquiryQueryKey = (options: Options<FindInquiryData>) => createQueryKey('findInquiry', options);

/**
 * 상품 문의 상세 조회
 *
 * 상품 문의 상세 조회
 */
export const findInquiryOptions = (options: Options<FindInquiryData>) => queryOptions<FindInquiryResponse, FindInquiryError, FindInquiryResponse, ReturnType<typeof findInquiryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findInquiry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findInquiryQueryKey(options)
});

export const getProductDetailByProductNumberQueryKey = (options: Options<GetProductDetailByProductNumberData>) => createQueryKey('getProductDetailByProductNumber', options);

/**
 * 상품번호로 상품 상세 조회
 *
 * 상품번호로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>}</p>
 *
 * <p>상품번호(productNumber)는 상품 등록 시 자동 생성되는 고유 식별자이다.
 * 컨트롤러 레벨에서 정규식 패턴을 검증하여, 형식에 맞지 않는 요청은
 * DB 조회 없이 즉시 에러를 반환한다.</p>
 */
export const getProductDetailByProductNumberOptions = (options: Options<GetProductDetailByProductNumberData>) => queryOptions<GetProductDetailByProductNumberResponse, GetProductDetailByProductNumberError, GetProductDetailByProductNumberResponse, ReturnType<typeof getProductDetailByProductNumberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductDetailByProductNumber({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductDetailByProductNumberQueryKey(options)
});

export const getProductSeoQueryKey = (options: Options<GetProductSeoData>) => createQueryKey('getProductSeo', options);

/**
 * 상품번호로 SEO 정보 조회 (비인증)
 *
 * 상품번호로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>/seo}</p>
 */
export const getProductSeoOptions = (options: Options<GetProductSeoData>) => queryOptions<GetProductSeoResponse, GetProductSeoError, GetProductSeoResponse, ReturnType<typeof getProductSeoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductSeo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductSeoQueryKey(options)
});

export const getProductFeedListQueryKey = (options?: Options<GetProductFeedListData>) => createQueryKey('getProductFeedList', options);

/**
 * 상품 피드 목록 조회 (메인)
 *
 * 상품 피드 목록 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/product-feeds</code></p>
 *
 * <p>판매중인 상품을 페이징하여 조회합니다.
 * 태그(프리미엄/최저가도전/무료배송), 리뷰 통계, 가격/할인 정보를 포함합니다.</p>
 */
export const getProductFeedListOptions = (options?: Options<GetProductFeedListData>) => queryOptions<GetProductFeedListResponse, GetProductFeedListError, GetProductFeedListResponse, ReturnType<typeof getProductFeedListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductFeedList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductFeedListQueryKey(options)
});

export const getProductFeedListInfiniteQueryKey = (options?: Options<GetProductFeedListData>): QueryKey<Options<GetProductFeedListData>> => createQueryKey('getProductFeedList', options, true);

/**
 * 상품 피드 목록 조회 (메인)
 *
 * 상품 피드 목록 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/product-feeds</code></p>
 *
 * <p>판매중인 상품을 페이징하여 조회합니다.
 * 태그(프리미엄/최저가도전/무료배송), 리뷰 통계, 가격/할인 정보를 포함합니다.</p>
 */
export const getProductFeedListInfiniteOptions = (options?: Options<GetProductFeedListData>) => infiniteQueryOptions<GetProductFeedListResponse, GetProductFeedListError, InfiniteData<GetProductFeedListResponse>, QueryKey<Options<GetProductFeedListData>>, number | Pick<QueryKey<Options<GetProductFeedListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetProductFeedListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getProductFeedList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductFeedListInfiniteQueryKey(options)
});

export const getGiftReviewFeedQueryKey = (options: Options<GetGiftReviewFeedData>) => createQueryKey('getGiftReviewFeed', options);

/**
 * 기부자 만족 상품 피드 조회 (메인 화면)
 *
 * 기부자 만족 상품 피드 조회.
 *
 * <p>상품 ID로 매핑된 답례품의 기부자 만족도와 리뷰 미리보기를 반환합니다.
 * 리뷰는 최신순 N건만 반환됩니다.</p>
 */
export const getGiftReviewFeedOptions = (options: Options<GetGiftReviewFeedData>) => queryOptions<GetGiftReviewFeedResponse, GetGiftReviewFeedError, GetGiftReviewFeedResponse, ReturnType<typeof getGiftReviewFeedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftReviewFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftReviewFeedQueryKey(options)
});

export const findGeneralDownloadableCouponsQueryKey = (options: Options<FindGeneralDownloadableCouponsData>) => createQueryKey('findGeneralDownloadableCoupons', options);

/**
 * 일반 다운로드 가능 쿠폰 목록 조회 (공개)
 *
 * 비인증 사용자용 상품별 일반 다운로드 가능 쿠폰 목록 조회
 */
export const findGeneralDownloadableCouponsOptions = (options: Options<FindGeneralDownloadableCouponsData>) => queryOptions<FindGeneralDownloadableCouponsResponse, FindGeneralDownloadableCouponsError, FindGeneralDownloadableCouponsResponse, ReturnType<typeof findGeneralDownloadableCouponsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGeneralDownloadableCoupons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGeneralDownloadableCouponsQueryKey(options)
});

export const getInstitutionSpecialtyListQueryKey = (options?: Options<GetInstitutionSpecialtyListData>) => createQueryKey('getInstitutionSpecialtyList', options);

/**
 * 지역별 특산품
 */
export const getInstitutionSpecialtyListOptions = (options?: Options<GetInstitutionSpecialtyListData>) => queryOptions<GetInstitutionSpecialtyListResponse, GetInstitutionSpecialtyListError, GetInstitutionSpecialtyListResponse, ReturnType<typeof getInstitutionSpecialtyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstitutionSpecialtyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstitutionSpecialtyListQueryKey(options)
});

export const allowsInterestPolicyListQueryKey = (options: Options<AllowsInterestPolicyListData>) => createQueryKey('allowsInterestPolicyList', options);

/**
 * 관심 분야별 정책 조회
 */
export const allowsInterestPolicyListOptions = (options: Options<AllowsInterestPolicyListData>) => queryOptions<AllowsInterestPolicyListResponse, AllowsInterestPolicyListError, AllowsInterestPolicyListResponse, ReturnType<typeof allowsInterestPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await allowsInterestPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: allowsInterestPolicyListQueryKey(options)
});

export const allowsInterestPolicyListInfiniteQueryKey = (options: Options<AllowsInterestPolicyListData>): QueryKey<Options<AllowsInterestPolicyListData>> => createQueryKey('allowsInterestPolicyList', options, true);

/**
 * 관심 분야별 정책 조회
 */
export const allowsInterestPolicyListInfiniteOptions = (options: Options<AllowsInterestPolicyListData>) => infiniteQueryOptions<AllowsInterestPolicyListResponse, AllowsInterestPolicyListError, InfiniteData<AllowsInterestPolicyListResponse>, QueryKey<Options<AllowsInterestPolicyListData>>, number | Pick<QueryKey<Options<AllowsInterestPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AllowsInterestPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await allowsInterestPolicyList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: allowsInterestPolicyListInfiniteQueryKey(options)
});

export const hometownNewsQueryKey = (options: Options<HometownNewsData>) => createQueryKey('hometownNews', options);

/**
 * 동네 소식 상세
 */
export const hometownNewsOptions = (options: Options<HometownNewsData>) => queryOptions<HometownNewsResponse, HometownNewsError, HometownNewsResponse, ReturnType<typeof hometownNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hometownNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hometownNewsQueryKey(options)
});

export const getRelatedHometownNewsListQueryKey = (options: Options<GetRelatedHometownNewsListData>) => createQueryKey('getRelatedHometownNewsList', options);

/**
 * 관련 동네소식 목록 조회(최대 10개)
 */
export const getRelatedHometownNewsListOptions = (options: Options<GetRelatedHometownNewsListData>) => queryOptions<GetRelatedHometownNewsListResponse, GetRelatedHometownNewsListError, GetRelatedHometownNewsListResponse, ReturnType<typeof getRelatedHometownNewsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRelatedHometownNewsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRelatedHometownNewsListQueryKey(options)
});

export const hometownNewsFeedbackQueryKey = (options: Options<HometownNewsFeedbackData>) => createQueryKey('hometownNewsFeedback', options);

/**
 * 비로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const hometownNewsFeedbackOptions = (options: Options<HometownNewsFeedbackData>) => queryOptions<HometownNewsFeedbackResponse, HometownNewsFeedbackError, HometownNewsFeedbackResponse, ReturnType<typeof hometownNewsFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hometownNewsFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hometownNewsFeedbackQueryKey(options)
});

export const getHomeInstitutionQueryKey = (options: Options<GetHomeInstitutionData>) => createQueryKey('getHomeInstitution', options);

/**
 * 지자체 정보 조회
 */
export const getHomeInstitutionOptions = (options: Options<GetHomeInstitutionData>) => queryOptions<GetHomeInstitutionResponse, GetHomeInstitutionError, GetHomeInstitutionResponse, ReturnType<typeof getHomeInstitutionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionQueryKey(options)
});

export const getHomeInstitutionBenefitRegionListQueryKey = (options: Options<GetHomeInstitutionBenefitRegionListData>) => createQueryKey('getHomeInstitutionBenefitRegionList', options);

/**
 * 위경도 기반 혜택 제공기관 지역별 갯수 검색
 */
export const getHomeInstitutionBenefitRegionListOptions = (options: Options<GetHomeInstitutionBenefitRegionListData>) => queryOptions<GetHomeInstitutionBenefitRegionListResponse, GetHomeInstitutionBenefitRegionListError, GetHomeInstitutionBenefitRegionListResponse, ReturnType<typeof getHomeInstitutionBenefitRegionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitRegionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitRegionListQueryKey(options)
});

export const getHomeInstitutionBenefitListQueryKey = (options: Options<GetHomeInstitutionBenefitListData>) => createQueryKey('getHomeInstitutionBenefitList', options);

/**
 * 위경도 기반 혜택 제공기관 검색
 */
export const getHomeInstitutionBenefitListOptions = (options: Options<GetHomeInstitutionBenefitListData>) => queryOptions<GetHomeInstitutionBenefitListResponse, GetHomeInstitutionBenefitListError, GetHomeInstitutionBenefitListResponse, ReturnType<typeof getHomeInstitutionBenefitListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitListQueryKey(options)
});

export const getHomeInstitutionBenefitListInfiniteQueryKey = (options: Options<GetHomeInstitutionBenefitListData>): QueryKey<Options<GetHomeInstitutionBenefitListData>> => createQueryKey('getHomeInstitutionBenefitList', options, true);

/**
 * 위경도 기반 혜택 제공기관 검색
 */
export const getHomeInstitutionBenefitListInfiniteOptions = (options: Options<GetHomeInstitutionBenefitListData>) => infiniteQueryOptions<GetHomeInstitutionBenefitListResponse, GetHomeInstitutionBenefitListError, InfiniteData<GetHomeInstitutionBenefitListResponse>, QueryKey<Options<GetHomeInstitutionBenefitListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionBenefitListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeInstitutionBenefitListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeInstitutionBenefitList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitListInfiniteQueryKey(options)
});

export const getHomeInstitutionBenefitListAllQueryKey = (options: Options<GetHomeInstitutionBenefitListAllData>) => createQueryKey('getHomeInstitutionBenefitListAll', options);

/**
 * 위경도 기반 혜텍 제공기관 전체 검색
 */
export const getHomeInstitutionBenefitListAllOptions = (options: Options<GetHomeInstitutionBenefitListAllData>) => queryOptions<GetHomeInstitutionBenefitListAllResponse, GetHomeInstitutionBenefitListAllError, GetHomeInstitutionBenefitListAllResponse, ReturnType<typeof getHomeInstitutionBenefitListAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitListAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitListAllQueryKey(options)
});

export const getHomeInstitutionBenefitListAllInfiniteQueryKey = (options: Options<GetHomeInstitutionBenefitListAllData>): QueryKey<Options<GetHomeInstitutionBenefitListAllData>> => createQueryKey('getHomeInstitutionBenefitListAll', options, true);

/**
 * 위경도 기반 혜텍 제공기관 전체 검색
 */
export const getHomeInstitutionBenefitListAllInfiniteOptions = (options: Options<GetHomeInstitutionBenefitListAllData>) => infiniteQueryOptions<GetHomeInstitutionBenefitListAllResponse, GetHomeInstitutionBenefitListAllError, InfiniteData<GetHomeInstitutionBenefitListAllResponse>, QueryKey<Options<GetHomeInstitutionBenefitListAllData>>, number | Pick<QueryKey<Options<GetHomeInstitutionBenefitListAllData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeInstitutionBenefitListAllData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeInstitutionBenefitListAll({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitListAllInfiniteQueryKey(options)
});

export const getHomeInstitutionBenefitPublicListQueryKey = (options: Options<GetHomeInstitutionBenefitPublicListData>) => createQueryKey('getHomeInstitutionBenefitPublicList', options);

/**
 * 위경도 기반 혜텍 제공기관 - 공영
 */
export const getHomeInstitutionBenefitPublicListOptions = (options: Options<GetHomeInstitutionBenefitPublicListData>) => queryOptions<GetHomeInstitutionBenefitPublicListResponse, GetHomeInstitutionBenefitPublicListError, GetHomeInstitutionBenefitPublicListResponse, ReturnType<typeof getHomeInstitutionBenefitPublicListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitPublicList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitPublicListQueryKey(options)
});

export const getHomeInstitutionBenefitPrivateListQueryKey = (options: Options<GetHomeInstitutionBenefitPrivateListData>) => createQueryKey('getHomeInstitutionBenefitPrivateList', options);

/**
 * 위경도 기반 혜텍 제공기관 - 민영
 */
export const getHomeInstitutionBenefitPrivateListOptions = (options: Options<GetHomeInstitutionBenefitPrivateListData>) => queryOptions<GetHomeInstitutionBenefitPrivateListResponse, GetHomeInstitutionBenefitPrivateListError, GetHomeInstitutionBenefitPrivateListResponse, ReturnType<typeof getHomeInstitutionBenefitPrivateListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitPrivateList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitPrivateListQueryKey(options)
});

export const getHomeInstitutionPolicyListQueryKey = (options: Options<GetHomeInstitutionPolicyListData>) => createQueryKey('getHomeInstitutionPolicyList', options);

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyListOptions = (options: Options<GetHomeInstitutionPolicyListData>) => queryOptions<GetHomeInstitutionPolicyListResponse, GetHomeInstitutionPolicyListError, GetHomeInstitutionPolicyListResponse, ReturnType<typeof getHomeInstitutionPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionPolicyListQueryKey(options)
});

export const getHomeInstitutionPolicyListInfiniteQueryKey = (options: Options<GetHomeInstitutionPolicyListData>): QueryKey<Options<GetHomeInstitutionPolicyListData>> => createQueryKey('getHomeInstitutionPolicyList', options, true);

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyListInfiniteOptions = (options: Options<GetHomeInstitutionPolicyListData>) => infiniteQueryOptions<GetHomeInstitutionPolicyListResponse, GetHomeInstitutionPolicyListError, InfiniteData<GetHomeInstitutionPolicyListResponse>, QueryKey<Options<GetHomeInstitutionPolicyListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeInstitutionPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeInstitutionPolicyList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionPolicyListInfiniteQueryKey(options)
});

export const getHomeInstitutionListForSearchFilterQueryKey = (options?: Options<GetHomeInstitutionListForSearchFilterData>) => createQueryKey('getHomeInstitutionListForSearchFilter', options);

/**
 * 지자체 목록 조회(검색필터용)
 */
export const getHomeInstitutionListForSearchFilterOptions = (options?: Options<GetHomeInstitutionListForSearchFilterData>) => queryOptions<GetHomeInstitutionListForSearchFilterResponse, GetHomeInstitutionListForSearchFilterError, GetHomeInstitutionListForSearchFilterResponse, ReturnType<typeof getHomeInstitutionListForSearchFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionListForSearchFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionListForSearchFilterQueryKey(options)
});

export const getHomeLoveGovCodeToIdQueryKey = (options: Options<GetHomeLoveGovCodeToIdData>) => createQueryKey('getHomeLoveGovCodeToId', options);

/**
 * 지자체 코드로 ID 조회
 */
export const getHomeLoveGovCodeToIdOptions = (options: Options<GetHomeLoveGovCodeToIdData>) => queryOptions<GetHomeLoveGovCodeToIdResponse, GetHomeLoveGovCodeToIdError, GetHomeLoveGovCodeToIdResponse, ReturnType<typeof getHomeLoveGovCodeToIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeLoveGovCodeToId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeLoveGovCodeToIdQueryKey(options)
});

export const getHomeInstitutionEventListQueryKey = (options?: Options<GetHomeInstitutionEventListData>) => createQueryKey('getHomeInstitutionEventList', options);

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventListOptions = (options?: Options<GetHomeInstitutionEventListData>) => queryOptions<GetHomeInstitutionEventListResponse, GetHomeInstitutionEventListError, GetHomeInstitutionEventListResponse, ReturnType<typeof getHomeInstitutionEventListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionEventList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionEventListQueryKey(options)
});

export const getHomeInstitutionEventListInfiniteQueryKey = (options?: Options<GetHomeInstitutionEventListData>): QueryKey<Options<GetHomeInstitutionEventListData>> => createQueryKey('getHomeInstitutionEventList', options, true);

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventListInfiniteOptions = (options?: Options<GetHomeInstitutionEventListData>) => infiniteQueryOptions<GetHomeInstitutionEventListResponse, GetHomeInstitutionEventListError, InfiniteData<GetHomeInstitutionEventListResponse>, QueryKey<Options<GetHomeInstitutionEventListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionEventListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeInstitutionEventListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeInstitutionEventList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionEventListInfiniteQueryKey(options)
});

export const getHomeInstitutionEventQueryKey = (options: Options<GetHomeInstitutionEventData>) => createQueryKey('getHomeInstitutionEvent', options);

/**
 * 지자체 이벤트 상세 조회
 */
export const getHomeInstitutionEventOptions = (options: Options<GetHomeInstitutionEventData>) => queryOptions<GetHomeInstitutionEventResponse, GetHomeInstitutionEventError, GetHomeInstitutionEventResponse, ReturnType<typeof getHomeInstitutionEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionEventQueryKey(options)
});

export const getOrderedHomeInstitutionEventListQueryKey = (options?: Options<GetOrderedHomeInstitutionEventListData>) => createQueryKey('getOrderedHomeInstitutionEventList', options);

/**
 * 지자체 이벤트 목록 조회(정렬)
 */
export const getOrderedHomeInstitutionEventListOptions = (options?: Options<GetOrderedHomeInstitutionEventListData>) => queryOptions<GetOrderedHomeInstitutionEventListResponse, GetOrderedHomeInstitutionEventListError, GetOrderedHomeInstitutionEventListResponse, ReturnType<typeof getOrderedHomeInstitutionEventListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderedHomeInstitutionEventList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderedHomeInstitutionEventListQueryKey(options)
});

export const getHomeInstitutionContentListQueryKey = (options?: Options<GetHomeInstitutionContentListData>) => createQueryKey('getHomeInstitutionContentList', options);

/**
 * 지자체 컨텐츠 목록 조회
 */
export const getHomeInstitutionContentListOptions = (options?: Options<GetHomeInstitutionContentListData>) => queryOptions<GetHomeInstitutionContentListResponse, GetHomeInstitutionContentListError, GetHomeInstitutionContentListResponse, ReturnType<typeof getHomeInstitutionContentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionContentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionContentListQueryKey(options)
});

export const getHomeInstitutionContentListInfiniteQueryKey = (options?: Options<GetHomeInstitutionContentListData>): QueryKey<Options<GetHomeInstitutionContentListData>> => createQueryKey('getHomeInstitutionContentList', options, true);

/**
 * 지자체 컨텐츠 목록 조회
 */
export const getHomeInstitutionContentListInfiniteOptions = (options?: Options<GetHomeInstitutionContentListData>) => infiniteQueryOptions<GetHomeInstitutionContentListResponse, GetHomeInstitutionContentListError, InfiniteData<GetHomeInstitutionContentListResponse>, QueryKey<Options<GetHomeInstitutionContentListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionContentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeInstitutionContentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeInstitutionContentList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionContentListInfiniteQueryKey(options)
});

export const getHomeInstitutionContentQueryKey = (options: Options<GetHomeInstitutionContentData>) => createQueryKey('getHomeInstitutionContent', options);

/**
 * 지자체 컨텐츠 상세 조회
 */
export const getHomeInstitutionContentOptions = (options: Options<GetHomeInstitutionContentData>) => queryOptions<GetHomeInstitutionContentResponse, GetHomeInstitutionContentError, GetHomeInstitutionContentResponse, ReturnType<typeof getHomeInstitutionContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionContentQueryKey(options)
});

export const getGiftOrderProductReviewListQueryKey = (options?: Options<GetGiftOrderProductReviewListData>) => createQueryKey('getGiftOrderProductReviewList', options);

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewListOptions = (options?: Options<GetGiftOrderProductReviewListData>) => queryOptions<GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewListError, GetGiftOrderProductReviewListResponse, ReturnType<typeof getGiftOrderProductReviewListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftOrderProductReviewList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductReviewListQueryKey(options)
});

export const getGiftOrderProductReviewListInfiniteQueryKey = (options?: Options<GetGiftOrderProductReviewListData>): QueryKey<Options<GetGiftOrderProductReviewListData>> => createQueryKey('getGiftOrderProductReviewList', options, true);

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewListInfiniteOptions = (options?: Options<GetGiftOrderProductReviewListData>) => infiniteQueryOptions<GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewListError, InfiniteData<GetGiftOrderProductReviewListResponse>, QueryKey<Options<GetGiftOrderProductReviewListData>>, number | Pick<QueryKey<Options<GetGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getGiftOrderProductReviewList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductReviewListInfiniteQueryKey(options)
});

export const getGiftOrderProductReviewQueryKey = (options: Options<GetGiftOrderProductReviewData>) => createQueryKey('getGiftOrderProductReview', options);

/**
 * 리뷰 상세 조회
 */
export const getGiftOrderProductReviewOptions = (options: Options<GetGiftOrderProductReviewData>) => queryOptions<GetGiftOrderProductReviewResponse, GetGiftOrderProductReviewError, GetGiftOrderProductReviewResponse, ReturnType<typeof getGiftOrderProductReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftOrderProductReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductReviewQueryKey(options)
});

export const getGiftOrderProductPhotoReviewListByProductQueryKey = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>) => createQueryKey('getGiftOrderProductPhotoReviewListByProduct', options);

/**
 * 후기 목록(포토리뷰) 조회
 */
export const getGiftOrderProductPhotoReviewListByProductOptions = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>) => queryOptions<GetGiftOrderProductPhotoReviewListByProductResponse, GetGiftOrderProductPhotoReviewListByProductError, GetGiftOrderProductPhotoReviewListByProductResponse, ReturnType<typeof getGiftOrderProductPhotoReviewListByProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftOrderProductPhotoReviewListByProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductPhotoReviewListByProductQueryKey(options)
});

export const getGiftOrderProductPhotoReviewListByProductInfiniteQueryKey = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>): QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>> => createQueryKey('getGiftOrderProductPhotoReviewListByProduct', options, true);

/**
 * 후기 목록(포토리뷰) 조회
 */
export const getGiftOrderProductPhotoReviewListByProductInfiniteOptions = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>) => infiniteQueryOptions<GetGiftOrderProductPhotoReviewListByProductResponse, GetGiftOrderProductPhotoReviewListByProductError, InfiniteData<GetGiftOrderProductPhotoReviewListByProductResponse>, QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>>, number | Pick<QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getGiftOrderProductPhotoReviewListByProduct({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductPhotoReviewListByProductInfiniteQueryKey(options)
});

export const getGiftProductList1QueryKey = (options?: Options<GetGiftProductList1Data>) => createQueryKey('getGiftProductList1', options);

/**
 * 답례품 목록 조회
 */
export const getGiftProductList1Options = (options?: Options<GetGiftProductList1Data>) => queryOptions<GetGiftProductList1Response, GetGiftProductList1Error, GetGiftProductList1Response, ReturnType<typeof getGiftProductList1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProductList1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductList1QueryKey(options)
});

export const getGiftProductList1InfiniteQueryKey = (options?: Options<GetGiftProductList1Data>): QueryKey<Options<GetGiftProductList1Data>> => createQueryKey('getGiftProductList1', options, true);

/**
 * 답례품 목록 조회
 */
export const getGiftProductList1InfiniteOptions = (options?: Options<GetGiftProductList1Data>) => infiniteQueryOptions<GetGiftProductList1Response, GetGiftProductList1Error, InfiniteData<GetGiftProductList1Response>, QueryKey<Options<GetGiftProductList1Data>>, number | Pick<QueryKey<Options<GetGiftProductList1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetGiftProductList1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getGiftProductList1({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductList1InfiniteQueryKey(options)
});

export const getGiftProductQueryKey = (options: Options<GetGiftProductData>) => createQueryKey('getGiftProduct', options);

/**
 * 답례품 상세 조회
 */
export const getGiftProductOptions = (options: Options<GetGiftProductData>) => queryOptions<GetGiftProductResponse, GetGiftProductError, GetGiftProductResponse, ReturnType<typeof getGiftProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductQueryKey(options)
});

export const getRelatedGiftProductListQueryKey = (options: Options<GetRelatedGiftProductListData>) => createQueryKey('getRelatedGiftProductList', options);

/**
 * 관련 답례품 목록(동일 지자체) 조회(top 4)
 */
export const getRelatedGiftProductListOptions = (options: Options<GetRelatedGiftProductListData>) => queryOptions<GetRelatedGiftProductListResponse, GetRelatedGiftProductListError, GetRelatedGiftProductListResponse, ReturnType<typeof getRelatedGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRelatedGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRelatedGiftProductListQueryKey(options)
});

export const searchGiftProductListQueryKey = (options: Options<SearchGiftProductListData>) => createQueryKey('searchGiftProductList', options);

/**
 * 답례품 목록 조회(동일, 처음 문자열 일치)
 */
export const searchGiftProductListOptions = (options: Options<SearchGiftProductListData>) => queryOptions<SearchGiftProductListResponse, SearchGiftProductListError, SearchGiftProductListResponse, ReturnType<typeof searchGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGiftProductListQueryKey(options)
});

export const searchGiftProductListInfiniteQueryKey = (options: Options<SearchGiftProductListData>): QueryKey<Options<SearchGiftProductListData>> => createQueryKey('searchGiftProductList', options, true);

/**
 * 답례품 목록 조회(동일, 처음 문자열 일치)
 */
export const searchGiftProductListInfiniteOptions = (options: Options<SearchGiftProductListData>) => infiniteQueryOptions<SearchGiftProductListResponse, SearchGiftProductListError, InfiniteData<SearchGiftProductListResponse>, QueryKey<Options<SearchGiftProductListData>>, number | Pick<QueryKey<Options<SearchGiftProductListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchGiftProductListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchGiftProductList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGiftProductListInfiniteQueryKey(options)
});

export const searchGiftProductListCountQueryKey = (options: Options<SearchGiftProductListCountData>) => createQueryKey('searchGiftProductListCount', options);

/**
 * 답례품 목록 조회 총 건수
 */
export const searchGiftProductListCountOptions = (options: Options<SearchGiftProductListCountData>) => queryOptions<SearchGiftProductListCountResponse, SearchGiftProductListCountError, SearchGiftProductListCountResponse, ReturnType<typeof searchGiftProductListCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchGiftProductListCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGiftProductListCountQueryKey(options)
});

export const searchGiftProductListByContainsQueryKey = (options: Options<SearchGiftProductListByContainsData>) => createQueryKey('searchGiftProductListByContains', options);

/**
 * 답례품 목록 조회 - 포함(동일, 시작 문자열 제외)
 */
export const searchGiftProductListByContainsOptions = (options: Options<SearchGiftProductListByContainsData>) => queryOptions<SearchGiftProductListByContainsResponse, SearchGiftProductListByContainsError, SearchGiftProductListByContainsResponse, ReturnType<typeof searchGiftProductListByContainsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchGiftProductListByContains({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGiftProductListByContainsQueryKey(options)
});

export const searchGiftProductListByContainsInfiniteQueryKey = (options: Options<SearchGiftProductListByContainsData>): QueryKey<Options<SearchGiftProductListByContainsData>> => createQueryKey('searchGiftProductListByContains', options, true);

/**
 * 답례품 목록 조회 - 포함(동일, 시작 문자열 제외)
 */
export const searchGiftProductListByContainsInfiniteOptions = (options: Options<SearchGiftProductListByContainsData>) => infiniteQueryOptions<SearchGiftProductListByContainsResponse, SearchGiftProductListByContainsError, InfiniteData<SearchGiftProductListByContainsResponse>, QueryKey<Options<SearchGiftProductListByContainsData>>, number | Pick<QueryKey<Options<SearchGiftProductListByContainsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchGiftProductListByContainsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchGiftProductListByContains({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchGiftProductListByContainsInfiniteQueryKey(options)
});

export const getInstitutionGiftProductListQueryKey = (options: Options<GetInstitutionGiftProductListData>) => createQueryKey('getInstitutionGiftProductList', options);

/**
 * 특정 지자체 답례품 목록
 */
export const getInstitutionGiftProductListOptions = (options: Options<GetInstitutionGiftProductListData>) => queryOptions<GetInstitutionGiftProductListResponse, GetInstitutionGiftProductListError, GetInstitutionGiftProductListResponse, ReturnType<typeof getInstitutionGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstitutionGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstitutionGiftProductListQueryKey(options)
});

export const getGiftProductPopularByInstitutionListQueryKey = (options?: Options<GetGiftProductPopularByInstitutionListData>) => createQueryKey('getGiftProductPopularByInstitutionList', options);

/**
 * 지자체별 인기 답례품 조회
 */
export const getGiftProductPopularByInstitutionListOptions = (options?: Options<GetGiftProductPopularByInstitutionListData>) => queryOptions<GetGiftProductPopularByInstitutionListResponse, GetGiftProductPopularByInstitutionListError, GetGiftProductPopularByInstitutionListResponse, ReturnType<typeof getGiftProductPopularByInstitutionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProductPopularByInstitutionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductPopularByInstitutionListQueryKey(options)
});

export const getGiftProductListByInstitutionQueryKey = (options: Options<GetGiftProductListByInstitutionData>) => createQueryKey('getGiftProductListByInstitution', options);

/**
 * 지자체 답례품 목록 조회
 */
export const getGiftProductListByInstitutionOptions = (options: Options<GetGiftProductListByInstitutionData>) => queryOptions<GetGiftProductListByInstitutionResponse, GetGiftProductListByInstitutionError, GetGiftProductListByInstitutionResponse, ReturnType<typeof getGiftProductListByInstitutionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProductListByInstitution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductListByInstitutionQueryKey(options)
});

export const getGiftProductListByInstitutionInfiniteQueryKey = (options: Options<GetGiftProductListByInstitutionData>): QueryKey<Options<GetGiftProductListByInstitutionData>> => createQueryKey('getGiftProductListByInstitution', options, true);

/**
 * 지자체 답례품 목록 조회
 */
export const getGiftProductListByInstitutionInfiniteOptions = (options: Options<GetGiftProductListByInstitutionData>) => infiniteQueryOptions<GetGiftProductListByInstitutionResponse, GetGiftProductListByInstitutionError, InfiniteData<GetGiftProductListByInstitutionResponse>, QueryKey<Options<GetGiftProductListByInstitutionData>>, number | Pick<QueryKey<Options<GetGiftProductListByInstitutionData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetGiftProductListByInstitutionData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getGiftProductListByInstitution({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductListByInstitutionInfiniteQueryKey(options)
});

export const getGiftProductBlockListQueryKey = (options: Options<GetGiftProductBlockListData>) => createQueryKey('getGiftProductBlockList', options);

/**
 * 답례품 목록 조회(포토리뷰 포함)
 */
export const getGiftProductBlockListOptions = (options: Options<GetGiftProductBlockListData>) => queryOptions<GetGiftProductBlockListResponse, GetGiftProductBlockListError, GetGiftProductBlockListResponse, ReturnType<typeof getGiftProductBlockListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProductBlockList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductBlockListQueryKey(options)
});

export const getGiftProductBlockListInfiniteQueryKey = (options: Options<GetGiftProductBlockListData>): QueryKey<Options<GetGiftProductBlockListData>> => createQueryKey('getGiftProductBlockList', options, true);

/**
 * 답례품 목록 조회(포토리뷰 포함)
 */
export const getGiftProductBlockListInfiniteOptions = (options: Options<GetGiftProductBlockListData>) => infiniteQueryOptions<GetGiftProductBlockListResponse, GetGiftProductBlockListError, InfiniteData<GetGiftProductBlockListResponse>, QueryKey<Options<GetGiftProductBlockListData>>, number | Pick<QueryKey<Options<GetGiftProductBlockListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetGiftProductBlockListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getGiftProductBlockList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductBlockListInfiniteQueryKey(options)
});

export const getGiftProductSeoQueryKey = (options: Options<GetGiftProductSeoData>) => createQueryKey('getGiftProductSeo', options);

/**
 * 답례품 seo 조회
 */
export const getGiftProductSeoOptions = (options: Options<GetGiftProductSeoData>) => queryOptions<GetGiftProductSeoResponse, GetGiftProductSeoError, GetGiftProductSeoResponse, ReturnType<typeof getGiftProductSeoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProductSeo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductSeoQueryKey(options)
});

export const getPrimaryGiftCategoryListQueryKey = (options?: Options<GetPrimaryGiftCategoryListData>) => createQueryKey('getPrimaryGiftCategoryList', options);

/**
 * 답례품 카테고리 최상위 목록 조회
 */
export const getPrimaryGiftCategoryListOptions = (options?: Options<GetPrimaryGiftCategoryListData>) => queryOptions<GetPrimaryGiftCategoryListResponse, GetPrimaryGiftCategoryListError, GetPrimaryGiftCategoryListResponse, ReturnType<typeof getPrimaryGiftCategoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPrimaryGiftCategoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPrimaryGiftCategoryListQueryKey(options)
});

export const getDecemberRandomTicketWinnerListQueryKey = (options?: Options<GetDecemberRandomTicketWinnerListData>) => createQueryKey('getDecemberRandomTicketWinnerList', options);

/**
 * 랜덤티켓 당첨자 (3등 이상)
 */
export const getDecemberRandomTicketWinnerListOptions = (options?: Options<GetDecemberRandomTicketWinnerListData>) => queryOptions<GetDecemberRandomTicketWinnerListResponse, GetDecemberRandomTicketWinnerListError, GetDecemberRandomTicketWinnerListResponse, ReturnType<typeof getDecemberRandomTicketWinnerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecemberRandomTicketWinnerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecemberRandomTicketWinnerListQueryKey(options)
});

export const getDecemberInstitutionEventInfoListQueryKey = (options?: Options<GetDecemberInstitutionEventInfoListData>) => createQueryKey('getDecemberInstitutionEventInfoList', options);

/**
 * 지역별 기부 이벤트 현황
 */
export const getDecemberInstitutionEventInfoListOptions = (options?: Options<GetDecemberInstitutionEventInfoListData>) => queryOptions<GetDecemberInstitutionEventInfoListResponse, GetDecemberInstitutionEventInfoListError, GetDecemberInstitutionEventInfoListResponse, ReturnType<typeof getDecemberInstitutionEventInfoListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecemberInstitutionEventInfoList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecemberInstitutionEventInfoListQueryKey(options)
});

export const getDecemberEventGiftProductListQueryKey = (options?: Options<GetDecemberEventGiftProductListData>) => createQueryKey('getDecemberEventGiftProductList', options);

/**
 * 금일 Event2 답례품
 */
export const getDecemberEventGiftProductListOptions = (options?: Options<GetDecemberEventGiftProductListData>) => queryOptions<GetDecemberEventGiftProductListResponse, GetDecemberEventGiftProductListError, GetDecemberEventGiftProductListResponse, ReturnType<typeof getDecemberEventGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecemberEventGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecemberEventGiftProductListQueryKey(options)
});

export const getEventAmountInfoQueryKey = (options?: Options<GetEventAmountInfoData>) => createQueryKey('getEventAmountInfo', options);

/**
 * 12월 혜택 금액 정보 조회
 */
export const getEventAmountInfoOptions = (options?: Options<GetEventAmountInfoData>) => queryOptions<GetEventAmountInfoResponse, GetEventAmountInfoError, GetEventAmountInfoResponse, ReturnType<typeof getEventAmountInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventAmountInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventAmountInfoQueryKey(options)
});

export const getDonationBusinessListQueryKey = (options?: Options<GetDonationBusinessListData>) => createQueryKey('getDonationBusinessList', options);

/**
 * 지정 사업 목록
 */
export const getDonationBusinessListOptions = (options?: Options<GetDonationBusinessListData>) => queryOptions<GetDonationBusinessListResponse, GetDonationBusinessListError, GetDonationBusinessListResponse, ReturnType<typeof getDonationBusinessListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusinessList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessListQueryKey(options)
});

export const getDonationBusinessListInfiniteQueryKey = (options?: Options<GetDonationBusinessListData>): QueryKey<Options<GetDonationBusinessListData>> => createQueryKey('getDonationBusinessList', options, true);

/**
 * 지정 사업 목록
 */
export const getDonationBusinessListInfiniteOptions = (options?: Options<GetDonationBusinessListData>) => infiniteQueryOptions<GetDonationBusinessListResponse, GetDonationBusinessListError, InfiniteData<GetDonationBusinessListResponse>, QueryKey<Options<GetDonationBusinessListData>>, number | Pick<QueryKey<Options<GetDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getDonationBusinessList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessListInfiniteQueryKey(options)
});

export const getDonationBusinessQueryKey = (options: Options<GetDonationBusinessData>) => createQueryKey('getDonationBusiness', options);

/**
 * 지정 사업 상세
 */
export const getDonationBusinessOptions = (options: Options<GetDonationBusinessData>) => queryOptions<GetDonationBusinessResponse, GetDonationBusinessError, GetDonationBusinessResponse, ReturnType<typeof getDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessQueryKey(options)
});

export const getRelatedDonationBusinessQueryKey = (options: Options<GetRelatedDonationBusinessData>) => createQueryKey('getRelatedDonationBusiness', options);

/**
 * 관련 지정 사업 목록
 */
export const getRelatedDonationBusinessOptions = (options: Options<GetRelatedDonationBusinessData>) => queryOptions<GetRelatedDonationBusinessResponse, GetRelatedDonationBusinessError, GetRelatedDonationBusinessResponse, ReturnType<typeof getRelatedDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRelatedDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRelatedDonationBusinessQueryKey(options)
});

export const getDonationBusinessDetailCountQueryKey = (options: Options<GetDonationBusinessDetailCountData>) => createQueryKey('getDonationBusinessDetailCount', options);

/**
 * 지정 사업 상세 - 기부 & 응원 수 조회
 */
export const getDonationBusinessDetailCountOptions = (options: Options<GetDonationBusinessDetailCountData>) => queryOptions<GetDonationBusinessDetailCountResponse, GetDonationBusinessDetailCountError, GetDonationBusinessDetailCountResponse, ReturnType<typeof getDonationBusinessDetailCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusinessDetailCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessDetailCountQueryKey(options)
});

export const getInstitutionRelatedDonationBusinessQueryKey = (options: Options<GetInstitutionRelatedDonationBusinessData>) => createQueryKey('getInstitutionRelatedDonationBusiness', options);

/**
 * 특정 지자체 지정 사업 목록
 */
export const getInstitutionRelatedDonationBusinessOptions = (options: Options<GetInstitutionRelatedDonationBusinessData>) => queryOptions<GetInstitutionRelatedDonationBusinessResponse, GetInstitutionRelatedDonationBusinessError, GetInstitutionRelatedDonationBusinessResponse, ReturnType<typeof getInstitutionRelatedDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstitutionRelatedDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstitutionRelatedDonationBusinessQueryKey(options)
});

export const getHomeInstitutionDonationBusinessQueryKey = (options: Options<GetHomeInstitutionDonationBusinessData>) => createQueryKey('getHomeInstitutionDonationBusiness', options);

/**
 * 지자체 기부 가능한 지정 사업 조회
 */
export const getHomeInstitutionDonationBusinessOptions = (options: Options<GetHomeInstitutionDonationBusinessData>) => queryOptions<GetHomeInstitutionDonationBusinessResponse, GetHomeInstitutionDonationBusinessError, GetHomeInstitutionDonationBusinessResponse, ReturnType<typeof getHomeInstitutionDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionDonationBusinessQueryKey(options)
});

export const getDonationBusinessCommentListQueryKey = (options: Options<GetDonationBusinessCommentListData>) => createQueryKey('getDonationBusinessCommentList', options);

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentListOptions = (options: Options<GetDonationBusinessCommentListData>) => queryOptions<GetDonationBusinessCommentListResponse, GetDonationBusinessCommentListError, GetDonationBusinessCommentListResponse, ReturnType<typeof getDonationBusinessCommentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusinessCommentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessCommentListQueryKey(options)
});

export const getDonationBusinessCommentListInfiniteQueryKey = (options: Options<GetDonationBusinessCommentListData>): QueryKey<Options<GetDonationBusinessCommentListData>> => createQueryKey('getDonationBusinessCommentList', options, true);

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentListInfiniteOptions = (options: Options<GetDonationBusinessCommentListData>) => infiniteQueryOptions<GetDonationBusinessCommentListResponse, GetDonationBusinessCommentListError, InfiniteData<GetDonationBusinessCommentListResponse>, QueryKey<Options<GetDonationBusinessCommentListData>>, number | Pick<QueryKey<Options<GetDonationBusinessCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetDonationBusinessCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getDonationBusinessCommentList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessCommentListInfiniteQueryKey(options)
});

export const getAdminHomeSearchKeywordListQueryKey = (options: Options<GetAdminHomeSearchKeywordListData>) => createQueryKey('getAdminHomeSearchKeywordList', options);

/**
 * 검색 키워드 목록 조회
 */
export const getAdminHomeSearchKeywordListOptions = (options: Options<GetAdminHomeSearchKeywordListData>) => queryOptions<GetAdminHomeSearchKeywordListResponse, GetAdminHomeSearchKeywordListError, GetAdminHomeSearchKeywordListResponse, ReturnType<typeof getAdminHomeSearchKeywordListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminHomeSearchKeywordList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminHomeSearchKeywordListQueryKey(options)
});

export const getHomePopupNoticeQueryKey = (options: Options<GetHomePopupNoticeData>) => createQueryKey('getHomePopupNotice', options);

export const getHomePopupNoticeOptions = (options: Options<GetHomePopupNoticeData>) => queryOptions<GetHomePopupNoticeResponse, GetHomePopupNoticeError, GetHomePopupNoticeResponse, ReturnType<typeof getHomePopupNoticeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomePopupNotice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomePopupNoticeQueryKey(options)
});

export const getHomeNoticeListQueryKey = (options?: Options<GetHomeNoticeListData>) => createQueryKey('getHomeNoticeList', options);

/**
 * 목록 조회
 */
export const getHomeNoticeListOptions = (options?: Options<GetHomeNoticeListData>) => queryOptions<GetHomeNoticeListResponse, GetHomeNoticeListError, GetHomeNoticeListResponse, ReturnType<typeof getHomeNoticeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeNoticeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeNoticeListQueryKey(options)
});

export const getHomeNoticeListInfiniteQueryKey = (options?: Options<GetHomeNoticeListData>): QueryKey<Options<GetHomeNoticeListData>> => createQueryKey('getHomeNoticeList', options, true);

/**
 * 목록 조회
 */
export const getHomeNoticeListInfiniteOptions = (options?: Options<GetHomeNoticeListData>) => infiniteQueryOptions<GetHomeNoticeListResponse, GetHomeNoticeListError, InfiniteData<GetHomeNoticeListResponse>, QueryKey<Options<GetHomeNoticeListData>>, number | Pick<QueryKey<Options<GetHomeNoticeListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeNoticeListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeNoticeList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeNoticeListInfiniteQueryKey(options)
});

export const getHomeNoticeQueryKey = (options: Options<GetHomeNoticeData>) => createQueryKey('getHomeNotice', options);

/**
 * 상세 조회
 */
export const getHomeNoticeOptions = (options: Options<GetHomeNoticeData>) => queryOptions<GetHomeNoticeResponse, GetHomeNoticeError, GetHomeNoticeResponse, ReturnType<typeof getHomeNoticeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeNotice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeNoticeQueryKey(options)
});

export const getHomeLoveMainRecommendedInstitutionListQueryKey = (options?: Options<GetHomeLoveMainRecommendedInstitutionListData>) => createQueryKey('getHomeLoveMainRecommendedInstitutionList', options);

/**
 * 6.웰로가 추천하는 고향을 소개합니다
 *
 * @deprecated
 */
export const getHomeLoveMainRecommendedInstitutionListOptions = (options?: Options<GetHomeLoveMainRecommendedInstitutionListData>) => queryOptions<GetHomeLoveMainRecommendedInstitutionListResponse, GetHomeLoveMainRecommendedInstitutionListError, GetHomeLoveMainRecommendedInstitutionListResponse, ReturnType<typeof getHomeLoveMainRecommendedInstitutionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeLoveMainRecommendedInstitutionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeLoveMainRecommendedInstitutionListQueryKey(options)
});

export const getRecentDonatedGiftItemsQueryKey = (options?: Options<GetRecentDonatedGiftItemsData>) => createQueryKey('getRecentDonatedGiftItems', options);

/**
 * 5. 방금 기부하고 주문하신 답례품
 */
export const getRecentDonatedGiftItemsOptions = (options?: Options<GetRecentDonatedGiftItemsData>) => queryOptions<GetRecentDonatedGiftItemsResponse, GetRecentDonatedGiftItemsError, GetRecentDonatedGiftItemsResponse, ReturnType<typeof getRecentDonatedGiftItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentDonatedGiftItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentDonatedGiftItemsQueryKey(options)
});

export const getWeeklyBestGiftPhotoReviewsQueryKey = (options?: Options<GetWeeklyBestGiftPhotoReviewsData>) => createQueryKey('getWeeklyBestGiftPhotoReviews', options);

/**
 * 4. 주간 BEST 포토리뷰
 */
export const getWeeklyBestGiftPhotoReviewsOptions = (options?: Options<GetWeeklyBestGiftPhotoReviewsData>) => queryOptions<GetWeeklyBestGiftPhotoReviewsResponse, GetWeeklyBestGiftPhotoReviewsError, GetWeeklyBestGiftPhotoReviewsResponse, ReturnType<typeof getWeeklyBestGiftPhotoReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWeeklyBestGiftPhotoReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWeeklyBestGiftPhotoReviewsQueryKey(options)
});

export const getHomeInstitutionWithGiftProductListQueryKey = (options?: Options<GetHomeInstitutionWithGiftProductListData>) => createQueryKey('getHomeInstitutionWithGiftProductList', options);

/**
 * 8. 지역별 답례품
 */
export const getHomeInstitutionWithGiftProductListOptions = (options?: Options<GetHomeInstitutionWithGiftProductListData>) => queryOptions<GetHomeInstitutionWithGiftProductListResponse, GetHomeInstitutionWithGiftProductListError, GetHomeInstitutionWithGiftProductListResponse, ReturnType<typeof getHomeInstitutionWithGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionWithGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionWithGiftProductListQueryKey(options)
});

export const getHomeLoveMainInstitutionSpecialtyListQueryKey = (options?: Options<GetHomeLoveMainInstitutionSpecialtyListData>) => createQueryKey('getHomeLoveMainInstitutionSpecialtyList', options);

/**
 * 2. 지역별 특산품
 */
export const getHomeLoveMainInstitutionSpecialtyListOptions = (options?: Options<GetHomeLoveMainInstitutionSpecialtyListData>) => queryOptions<GetHomeLoveMainInstitutionSpecialtyListResponse, GetHomeLoveMainInstitutionSpecialtyListError, GetHomeLoveMainInstitutionSpecialtyListResponse, ReturnType<typeof getHomeLoveMainInstitutionSpecialtyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeLoveMainInstitutionSpecialtyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeLoveMainInstitutionSpecialtyListQueryKey(options)
});

export const getHomeLoveMainFeaturedDonationBusinessesListQueryKey = (options?: Options<GetHomeLoveMainFeaturedDonationBusinessesListData>) => createQueryKey('getHomeLoveMainFeaturedDonationBusinessesList', options);

/**
 * 7. 주목할 만한 고향사업
 */
export const getHomeLoveMainFeaturedDonationBusinessesListOptions = (options?: Options<GetHomeLoveMainFeaturedDonationBusinessesListData>) => queryOptions<GetHomeLoveMainFeaturedDonationBusinessesListResponse, GetHomeLoveMainFeaturedDonationBusinessesListError, GetHomeLoveMainFeaturedDonationBusinessesListResponse, ReturnType<typeof getHomeLoveMainFeaturedDonationBusinessesListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeLoveMainFeaturedDonationBusinessesList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeLoveMainFeaturedDonationBusinessesListQueryKey(options)
});

export const getHomeLoveMainDailyPickListQueryKey = (options?: Options<GetHomeLoveMainDailyPickListData>) => createQueryKey('getHomeLoveMainDailyPickList', options);

/**
 * 3. 오늘의 웰로 pick
 */
export const getHomeLoveMainDailyPickListOptions = (options?: Options<GetHomeLoveMainDailyPickListData>) => queryOptions<GetHomeLoveMainDailyPickListResponse, GetHomeLoveMainDailyPickListError, GetHomeLoveMainDailyPickListResponse, ReturnType<typeof getHomeLoveMainDailyPickListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeLoveMainDailyPickList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeLoveMainDailyPickListQueryKey(options)
});

export const callbackCompleteQueryKey = (options?: Options<CallbackCompleteData>) => createQueryKey('callbackComplete', options);

/**
 * 기부 완료 처리
 */
export const callbackCompleteOptions = (options?: Options<CallbackCompleteData>) => queryOptions<unknown, CallbackCompleteError, unknown, ReturnType<typeof callbackCompleteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await callbackComplete({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: callbackCompleteQueryKey(options)
});

export const getHomeInquiryListQueryKey = (options: Options<GetHomeInquiryListData>) => createQueryKey('getHomeInquiryList', options);

/**
 * 1:1 문의 목록 조회
 */
export const getHomeInquiryListOptions = (options: Options<GetHomeInquiryListData>) => queryOptions<GetHomeInquiryListResponse, GetHomeInquiryListError, GetHomeInquiryListResponse, ReturnType<typeof getHomeInquiryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInquiryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInquiryListQueryKey(options)
});

export const getHomeInquiryListInfiniteQueryKey = (options: Options<GetHomeInquiryListData>): QueryKey<Options<GetHomeInquiryListData>> => createQueryKey('getHomeInquiryList', options, true);

/**
 * 1:1 문의 목록 조회
 */
export const getHomeInquiryListInfiniteOptions = (options: Options<GetHomeInquiryListData>) => infiniteQueryOptions<GetHomeInquiryListResponse, GetHomeInquiryListError, InfiniteData<GetHomeInquiryListResponse>, QueryKey<Options<GetHomeInquiryListData>>, number | Pick<QueryKey<Options<GetHomeInquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeInquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeInquiryList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInquiryListInfiniteQueryKey(options)
});

export const getHomeInquiryQueryKey = (options: Options<GetHomeInquiryData>) => createQueryKey('getHomeInquiry', options);

/**
 * 1:1 문의 상세 조회
 */
export const getHomeInquiryOptions = (options: Options<GetHomeInquiryData>) => queryOptions<GetHomeInquiryResponse, GetHomeInquiryError, GetHomeInquiryResponse, ReturnType<typeof getHomeInquiryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInquiry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInquiryQueryKey(options)
});

export const getHomeDonationStatisticsListQueryKey = (options?: Options<GetHomeDonationStatisticsListData>) => createQueryKey('getHomeDonationStatisticsList', options);

/**
 * 지자체별 통계(기부자 수, 기부금액)
 */
export const getHomeDonationStatisticsListOptions = (options?: Options<GetHomeDonationStatisticsListData>) => queryOptions<GetHomeDonationStatisticsListResponse, GetHomeDonationStatisticsListError, GetHomeDonationStatisticsListResponse, ReturnType<typeof getHomeDonationStatisticsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeDonationStatisticsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationStatisticsListQueryKey(options)
});

export const getHomeDonationHistoryByDonationBusinessListQueryKey = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>) => createQueryKey('getHomeDonationHistoryByDonationBusinessList', options);

/**
 * 지정사업 기부내역 조회
 */
export const getHomeDonationHistoryByDonationBusinessListOptions = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>) => queryOptions<GetHomeDonationHistoryByDonationBusinessListResponse, GetHomeDonationHistoryByDonationBusinessListError, GetHomeDonationHistoryByDonationBusinessListResponse, ReturnType<typeof getHomeDonationHistoryByDonationBusinessListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeDonationHistoryByDonationBusinessList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationHistoryByDonationBusinessListQueryKey(options)
});

export const getHomeDonationHistoryByDonationBusinessListInfiniteQueryKey = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>): QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>> => createQueryKey('getHomeDonationHistoryByDonationBusinessList', options, true);

/**
 * 지정사업 기부내역 조회
 */
export const getHomeDonationHistoryByDonationBusinessListInfiniteOptions = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>) => infiniteQueryOptions<GetHomeDonationHistoryByDonationBusinessListResponse, GetHomeDonationHistoryByDonationBusinessListError, InfiniteData<GetHomeDonationHistoryByDonationBusinessListResponse>, QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>>, number | Pick<QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getHomeDonationHistoryByDonationBusinessList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationHistoryByDonationBusinessListInfiniteQueryKey(options)
});

export const calculateDonationQueryKey = (options: Options<CalculateDonationData>) => createQueryKey('calculateDonation', options);

/**
 * 기부금 계산
 */
export const calculateDonationOptions = (options: Options<CalculateDonationData>) => queryOptions<CalculateDonationResponse, CalculateDonationError, CalculateDonationResponse, ReturnType<typeof calculateDonationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await calculateDonation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: calculateDonationQueryKey(options)
});

export const getHomeDonationEventQueryKey = (options?: Options<GetHomeDonationEventData>) => createQueryKey('getHomeDonationEvent', options);

/**
 * 이벤트 목록 조회
 */
export const getHomeDonationEventOptions = (options?: Options<GetHomeDonationEventData>) => queryOptions<GetHomeDonationEventResponse, GetHomeDonationEventError, GetHomeDonationEventResponse, ReturnType<typeof getHomeDonationEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeDonationEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationEventQueryKey(options)
});

export const isEventInProgressQueryKey = (options: Options<IsEventInProgressData>) => createQueryKey('isEventInProgress', options);

/**
 * 이벤트 진행 여부
 */
export const isEventInProgressOptions = (options: Options<IsEventInProgressData>) => queryOptions<IsEventInProgressResponse, IsEventInProgressError, IsEventInProgressResponse, ReturnType<typeof isEventInProgressQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await isEventInProgress({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: isEventInProgressQueryKey(options)
});

export const getRecentEventHistoryListQueryKey = (options: Options<GetRecentEventHistoryListData>) => createQueryKey('getRecentEventHistoryList', options);

/**
 * 최근 포인트 지급 목록
 */
export const getRecentEventHistoryListOptions = (options: Options<GetRecentEventHistoryListData>) => queryOptions<GetRecentEventHistoryListResponse, GetRecentEventHistoryListError, GetRecentEventHistoryListResponse, ReturnType<typeof getRecentEventHistoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentEventHistoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentEventHistoryListQueryKey(options)
});

export const getRecentEventHistoryListInSeptemberQueryKey = (options: Options<GetRecentEventHistoryListInSeptemberData>) => createQueryKey('getRecentEventHistoryListInSeptember', options);

/**
 * 최근 포인트 지급 목록 (9월)
 */
export const getRecentEventHistoryListInSeptemberOptions = (options: Options<GetRecentEventHistoryListInSeptemberData>) => queryOptions<GetRecentEventHistoryListInSeptemberResponse, GetRecentEventHistoryListInSeptemberError, GetRecentEventHistoryListInSeptemberResponse, ReturnType<typeof getRecentEventHistoryListInSeptemberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentEventHistoryListInSeptember({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentEventHistoryListInSeptemberQueryKey(options)
});

export const getMemberNameByInviteCodeQueryKey = (options: Options<GetMemberNameByInviteCodeData>) => createQueryKey('getMemberNameByInviteCode', options);

/**
 * 초대코드로 회원 이름 조회
 */
export const getMemberNameByInviteCodeOptions = (options: Options<GetMemberNameByInviteCodeData>) => queryOptions<GetMemberNameByInviteCodeResponse, GetMemberNameByInviteCodeError, GetMemberNameByInviteCodeResponse, ReturnType<typeof getMemberNameByInviteCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMemberNameByInviteCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMemberNameByInviteCodeQueryKey(options)
});

export const getTopDonationEventHistoryListQueryKey = (options: Options<GetTopDonationEventHistoryListData>) => createQueryKey('getTopDonationEventHistoryList', options);

/**
 * 친구 기부 TOP 목록
 */
export const getTopDonationEventHistoryListOptions = (options: Options<GetTopDonationEventHistoryListData>) => queryOptions<GetTopDonationEventHistoryListResponse, GetTopDonationEventHistoryListError, GetTopDonationEventHistoryListResponse, ReturnType<typeof getTopDonationEventHistoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTopDonationEventHistoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTopDonationEventHistoryListQueryKey(options)
});

export const getRecentOpenedGiftBoxListQueryKey = (options?: Options<GetRecentOpenedGiftBoxListData>) => createQueryKey('getRecentOpenedGiftBoxList', options);

/**
 * 최근 선물상자 오픈 목록 조회
 */
export const getRecentOpenedGiftBoxListOptions = (options?: Options<GetRecentOpenedGiftBoxListData>) => queryOptions<GetRecentOpenedGiftBoxListResponse, GetRecentOpenedGiftBoxListError, GetRecentOpenedGiftBoxListResponse, ReturnType<typeof getRecentOpenedGiftBoxListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentOpenedGiftBoxList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentOpenedGiftBoxListQueryKey(options)
});

export const getTopInviterListInAugustQueryKey = (options?: Options<GetTopInviterListInAugustData>) => createQueryKey('getTopInviterListInAugust', options);

/**
 * 초대 TOP 목록 조회(8월)
 */
export const getTopInviterListInAugustOptions = (options?: Options<GetTopInviterListInAugustData>) => queryOptions<GetTopInviterListInAugustResponse, GetTopInviterListInAugustError, GetTopInviterListInAugustResponse, ReturnType<typeof getTopInviterListInAugustQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTopInviterListInAugust({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTopInviterListInAugustQueryKey(options)
});

export const getNCloudGeocodingByCodeQueryKey = (options: Options<GetNCloudGeocodingByCodeData>) => createQueryKey('getNCloudGeocodingByCode', options);

/**
 * 시군구 코드로 위/경도 조회
 */
export const getNCloudGeocodingByCodeOptions = (options: Options<GetNCloudGeocodingByCodeData>) => queryOptions<GetNCloudGeocodingByCodeResponse, GetNCloudGeocodingByCodeError, GetNCloudGeocodingByCodeResponse, ReturnType<typeof getNCloudGeocodingByCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNCloudGeocodingByCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNCloudGeocodingByCodeQueryKey(options)
});

export const iosCallbackQueryKey = (options?: Options<IosCallbackData>) => createQueryKey('iosCallback', options);

/**
 * 애드팝콘 오퍼월 iOS 리워드 콜백
 *
 * IGAWorks에서 iOS 리워드 지급 시 호출되는 콜백 API
 */
export const iosCallbackOptions = (options?: Options<IosCallbackData>) => queryOptions<IosCallbackResponse, IosCallbackError, IosCallbackResponse, ReturnType<typeof iosCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iosCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iosCallbackQueryKey(options)
});

export const androidCallbackQueryKey = (options?: Options<AndroidCallbackData>) => createQueryKey('androidCallback', options);

/**
 * 애드팝콘 오퍼월 Android 리워드 콜백
 *
 * IGAWorks에서 Android 리워드 지급 시 호출되는 콜백 API
 */
export const androidCallbackOptions = (options?: Options<AndroidCallbackData>) => queryOptions<AndroidCallbackResponse, AndroidCallbackError, AndroidCallbackResponse, ReturnType<typeof androidCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await androidCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: androidCallbackQueryKey(options)
});

export const expositionLinkUrlListQueryKey = (options?: Options<ExpositionLinkUrlListData>) => createQueryKey('expositionLinkUrlList', options);

/**
 * 정부박람회 링크 url 목록 조회
 */
export const expositionLinkUrlListOptions = (options?: Options<ExpositionLinkUrlListData>) => queryOptions<ExpositionLinkUrlListResponse, ExpositionLinkUrlListError, ExpositionLinkUrlListResponse, ReturnType<typeof expositionLinkUrlListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await expositionLinkUrlList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: expositionLinkUrlListQueryKey(options)
});

export const getEmergencyRoomListQueryKey = (options: Options<GetEmergencyRoomListData>) => createQueryKey('getEmergencyRoomList', options);

/**
 * 응급실 목록 조회
 */
export const getEmergencyRoomListOptions = (options: Options<GetEmergencyRoomListData>) => queryOptions<GetEmergencyRoomListResponse, GetEmergencyRoomListError, GetEmergencyRoomListResponse, ReturnType<typeof getEmergencyRoomListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomListQueryKey(options)
});

export const getEmergencyRoomListInfiniteQueryKey = (options: Options<GetEmergencyRoomListData>): QueryKey<Options<GetEmergencyRoomListData>> => createQueryKey('getEmergencyRoomList', options, true);

/**
 * 응급실 목록 조회
 */
export const getEmergencyRoomListInfiniteOptions = (options: Options<GetEmergencyRoomListData>) => infiniteQueryOptions<GetEmergencyRoomListResponse, GetEmergencyRoomListError, InfiniteData<GetEmergencyRoomListResponse>, QueryKey<Options<GetEmergencyRoomListData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetEmergencyRoomListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getEmergencyRoomList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomListInfiniteQueryKey(options)
});

export const getEmergencyRoomQueryKey = (options: Options<GetEmergencyRoomData>) => createQueryKey('getEmergencyRoom', options);

/**
 * 응급실 상세 조회
 */
export const getEmergencyRoomOptions = (options: Options<GetEmergencyRoomData>) => queryOptions<GetEmergencyRoomResponse, GetEmergencyRoomError, GetEmergencyRoomResponse, ReturnType<typeof getEmergencyRoomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomQueryKey(options)
});

export const getEmergencyRoomLiveQueryKey = (options: Options<GetEmergencyRoomLiveData>) => createQueryKey('getEmergencyRoomLive', options);

/**
 * 응급실 실시간 데이터 조회
 */
export const getEmergencyRoomLiveOptions = (options: Options<GetEmergencyRoomLiveData>) => queryOptions<GetEmergencyRoomLiveResponse, GetEmergencyRoomLiveError, GetEmergencyRoomLiveResponse, ReturnType<typeof getEmergencyRoomLiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomLive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomLiveQueryKey(options)
});

export const getEmergencyRoomRegionListQueryKey = (options: Options<GetEmergencyRoomRegionListData>) => createQueryKey('getEmergencyRoomRegionList', options);

/**
 * 응급실 지역별 갯수 조회
 */
export const getEmergencyRoomRegionListOptions = (options: Options<GetEmergencyRoomRegionListData>) => queryOptions<GetEmergencyRoomRegionListResponse, GetEmergencyRoomRegionListError, GetEmergencyRoomRegionListResponse, ReturnType<typeof getEmergencyRoomRegionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomRegionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomRegionListQueryKey(options)
});

export const getEmergencyRoomListCountQueryKey = (options: Options<GetEmergencyRoomListCountData>) => createQueryKey('getEmergencyRoomListCount', options);

/**
 * 응급실 목록 전체 개수 조회
 */
export const getEmergencyRoomListCountOptions = (options: Options<GetEmergencyRoomListCountData>) => queryOptions<GetEmergencyRoomListCountResponse, GetEmergencyRoomListCountError, GetEmergencyRoomListCountResponse, ReturnType<typeof getEmergencyRoomListCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomListCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomListCountQueryKey(options)
});

export const getEmergencyRoomListCountInfiniteQueryKey = (options: Options<GetEmergencyRoomListCountData>): QueryKey<Options<GetEmergencyRoomListCountData>> => createQueryKey('getEmergencyRoomListCount', options, true);

/**
 * 응급실 목록 전체 개수 조회
 */
export const getEmergencyRoomListCountInfiniteOptions = (options: Options<GetEmergencyRoomListCountData>) => infiniteQueryOptions<GetEmergencyRoomListCountResponse, GetEmergencyRoomListCountError, InfiniteData<GetEmergencyRoomListCountResponse>, QueryKey<Options<GetEmergencyRoomListCountData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListCountData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetEmergencyRoomListCountData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getEmergencyRoomListCount({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomListCountInfiniteQueryKey(options)
});

export const getEmergencyRoomCodeListQueryKey = (options?: Options<GetEmergencyRoomCodeListData>) => createQueryKey('getEmergencyRoomCodeList', options);

/**
 * 응급실 관련 코드 목록 조회
 */
export const getEmergencyRoomCodeListOptions = (options?: Options<GetEmergencyRoomCodeListData>) => queryOptions<GetEmergencyRoomCodeListResponse, GetEmergencyRoomCodeListError, GetEmergencyRoomCodeListResponse, ReturnType<typeof getEmergencyRoomCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomCodeListQueryKey(options)
});

export const noticeList1QueryKey = (options?: Options<NoticeList1Data>) => createQueryKey('noticeList1', options);

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const noticeList1Options = (options?: Options<NoticeList1Data>) => queryOptions<NoticeList1Response, NoticeList1Error, NoticeList1Response, ReturnType<typeof noticeList1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await noticeList1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: noticeList1QueryKey(options)
});

export const noticeQueryKey = (options: Options<NoticeData>) => createQueryKey('notice', options);

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const noticeOptions = (options: Options<NoticeData>) => queryOptions<NoticeResponse, NoticeError, NoticeResponse, ReturnType<typeof noticeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: noticeQueryKey(options)
});

export const faqListQueryKey = (options?: Options<FaqListData>) => createQueryKey('faqList', options);

/**
 * FAQ 목록 조회
 *
 * FAQ 목록을 조회합니다
 */
export const faqListOptions = (options?: Options<FaqListData>) => queryOptions<FaqListResponse, FaqListError, FaqListResponse, ReturnType<typeof faqListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await faqList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: faqListQueryKey(options)
});

export const getControlManagementsQueryKey = (options?: Options<GetControlManagementsData>) => createQueryKey('getControlManagements', options);

/**
 * 현재 제어관리 조회
 */
export const getControlManagementsOptions = (options?: Options<GetControlManagementsData>) => queryOptions<GetControlManagementsResponse, GetControlManagementsError, GetControlManagementsResponse, ReturnType<typeof getControlManagementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getControlManagements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getControlManagementsQueryKey(options)
});

export const situationListQueryKey = (options?: Options<SituationListData>) => createQueryKey('situationList', options);

/**
 * 정책 꾸러미 목록 조회
 *
 * 정책 꾸러미 목록을 조회합니다
 */
export const situationListOptions = (options?: Options<SituationListData>) => queryOptions<SituationListResponse2, SituationListError, SituationListResponse2, ReturnType<typeof situationListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await situationList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: situationListQueryKey(options)
});

export const getSituationPolicyListQueryKey = (options: Options<GetSituationPolicyListData>) => createQueryKey('getSituationPolicyList', options);

/**
 * 정책 꾸러미 정책 목록 조회
 *
 * 정책 꾸러미 정책 목록을 조회합니다
 */
export const getSituationPolicyListOptions = (options: Options<GetSituationPolicyListData>) => queryOptions<GetSituationPolicyListResponse, GetSituationPolicyListError, GetSituationPolicyListResponse, ReturnType<typeof getSituationPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSituationPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSituationPolicyListQueryKey(options)
});

export const welloPickListQueryKey = (options?: Options<WelloPickListData>) => createQueryKey('welloPickList', options);

/**
 * 웰로 대상별 정책 - 대상 조회
 *
 * 웰로 대상별 정책 - 대상 정보를 조회합니다
 */
export const welloPickListOptions = (options?: Options<WelloPickListData>) => queryOptions<WelloPickListResponse, WelloPickListError, WelloPickListResponse, ReturnType<typeof welloPickListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPickList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPickListQueryKey(options)
});

export const welloPickPolicyListQueryKey = (options: Options<WelloPickPolicyListData>) => createQueryKey('welloPickPolicyList', options);

/**
 * 웰로 대상별 정책 조회
 *
 * 웰로 대상별 정책 정보를 조회합니다
 */
export const welloPickPolicyListOptions = (options: Options<WelloPickPolicyListData>) => queryOptions<WelloPickPolicyListResponse, WelloPickPolicyListError, WelloPickPolicyListResponse, ReturnType<typeof welloPickPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPickPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPickPolicyListQueryKey(options)
});

export const getBestContentsQueryKey = (options: Options<GetBestContentsData>) => createQueryKey('getBestContents', options);

/**
 * 정책 소식 상세 조회
 */
export const getBestContentsOptions = (options: Options<GetBestContentsData>) => queryOptions<GetBestContentsResponse, GetBestContentsError, GetBestContentsResponse, ReturnType<typeof getBestContentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBestContents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBestContentsQueryKey(options)
});

export const bestContentsFeedbackQueryKey = (options: Options<BestContentsFeedbackData>) => createQueryKey('bestContentsFeedback', options);

/**
 * 정책 소식 내 고객정보 조회
 */
export const bestContentsFeedbackOptions = (options: Options<BestContentsFeedbackData>) => queryOptions<BestContentsFeedbackResponse, BestContentsFeedbackError, BestContentsFeedbackResponse, ReturnType<typeof bestContentsFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bestContentsFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bestContentsFeedbackQueryKey(options)
});

export const getCommunityWelloNewsListQueryKey = (options: Options<GetCommunityWelloNewsListData>) => createQueryKey('getCommunityWelloNewsList', options);

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsListOptions = (options: Options<GetCommunityWelloNewsListData>) => queryOptions<GetCommunityWelloNewsListResponse, GetCommunityWelloNewsListError, GetCommunityWelloNewsListResponse, ReturnType<typeof getCommunityWelloNewsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunityWelloNewsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityWelloNewsListQueryKey(options)
});

export const getCommunityWelloNewsListInfiniteQueryKey = (options: Options<GetCommunityWelloNewsListData>): QueryKey<Options<GetCommunityWelloNewsListData>> => createQueryKey('getCommunityWelloNewsList', options, true);

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsListInfiniteOptions = (options: Options<GetCommunityWelloNewsListData>) => infiniteQueryOptions<GetCommunityWelloNewsListResponse, GetCommunityWelloNewsListError, InfiniteData<GetCommunityWelloNewsListResponse>, QueryKey<Options<GetCommunityWelloNewsListData>>, number | Pick<QueryKey<Options<GetCommunityWelloNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetCommunityWelloNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getCommunityWelloNewsList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityWelloNewsListInfiniteQueryKey(options)
});

export const getCommunityWelloNewsQueryKey = (options: Options<GetCommunityWelloNewsData>) => createQueryKey('getCommunityWelloNews', options);

/**
 * 커뮤니티 - 웰로 소식 상세
 */
export const getCommunityWelloNewsOptions = (options: Options<GetCommunityWelloNewsData>) => queryOptions<GetCommunityWelloNewsResponse, GetCommunityWelloNewsError, GetCommunityWelloNewsResponse, ReturnType<typeof getCommunityWelloNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunityWelloNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityWelloNewsQueryKey(options)
});

export const feedbackCommunityWelloNewsQueryKey = (options: Options<FeedbackCommunityWelloNewsData>) => createQueryKey('feedbackCommunityWelloNews', options);

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const feedbackCommunityWelloNewsOptions = (options: Options<FeedbackCommunityWelloNewsData>) => queryOptions<FeedbackCommunityWelloNewsResponse, FeedbackCommunityWelloNewsError, FeedbackCommunityWelloNewsResponse, ReturnType<typeof feedbackCommunityWelloNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await feedbackCommunityWelloNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: feedbackCommunityWelloNewsQueryKey(options)
});

export const getCommunityCategoryQueryKey = (options: Options<GetCommunityCategoryData>) => createQueryKey('getCommunityCategory', options);

/**
 * 커뮤니티 카테고리 - 하위 카테고리 목록 조회
 */
export const getCommunityCategoryOptions = (options: Options<GetCommunityCategoryData>) => queryOptions<GetCommunityCategoryResponse, GetCommunityCategoryError, GetCommunityCategoryResponse, ReturnType<typeof getCommunityCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunityCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityCategoryQueryKey(options)
});

export const getCommunitySubcategoryListByCodeQueryKey = (options: Options<GetCommunitySubcategoryListByCodeData>) => createQueryKey('getCommunitySubcategoryListByCode', options);

/**
 * 커뮤니티 카테고리 - 서브 카테고리 목록 조회
 */
export const getCommunitySubcategoryListByCodeOptions = (options: Options<GetCommunitySubcategoryListByCodeData>) => queryOptions<GetCommunitySubcategoryListByCodeResponse, GetCommunitySubcategoryListByCodeError, GetCommunitySubcategoryListByCodeResponse, ReturnType<typeof getCommunitySubcategoryListByCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunitySubcategoryListByCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunitySubcategoryListByCodeQueryKey(options)
});

export const getCommunityMainCategoryListQueryKey = (options?: Options<GetCommunityMainCategoryListData>) => createQueryKey('getCommunityMainCategoryList', options);

/**
 * 커뮤니티 카테고리 - 메인 카테고리 목록 조회
 */
export const getCommunityMainCategoryListOptions = (options?: Options<GetCommunityMainCategoryListData>) => queryOptions<GetCommunityMainCategoryListResponse, GetCommunityMainCategoryListError, GetCommunityMainCategoryListResponse, ReturnType<typeof getCommunityMainCategoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunityMainCategoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityMainCategoryListQueryKey(options)
});

export const cardListQueryKey = (options: Options<CardListData>) => createQueryKey('cardList', options);

/**
 * 카드사 목록 조회
 */
export const cardListOptions = (options: Options<CardListData>) => queryOptions<CardListResponse, CardListError, CardListResponse, ReturnType<typeof cardListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await cardList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: cardListQueryKey(options)
});

export const bannerListQueryKey = (options: Options<BannerListData>) => createQueryKey('bannerList', options);

/**
 * 배너 목록 조회
 *
 * 배너 목록을 조회합니다
 */
export const bannerListOptions = (options: Options<BannerListData>) => queryOptions<BannerListResponse, BannerListError, BannerListResponse, ReturnType<typeof bannerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bannerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bannerListQueryKey(options)
});

export const bankListQueryKey = (options?: Options<BankListData>) => createQueryKey('bankList', options);

/**
 * 은행 목록 조회
 */
export const bankListOptions = (options?: Options<BankListData>) => queryOptions<BankListResponse, BankListError, BankListResponse, ReturnType<typeof bankListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bankList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bankListQueryKey(options)
});

export const availCardListQueryKey = (options: Options<AvailCardListData>) => createQueryKey('availCardList', options);

/**
 * 신청카드 목록 조회
 */
export const availCardListOptions = (options: Options<AvailCardListData>) => queryOptions<AvailCardListResponse, AvailCardListError, AvailCardListResponse, ReturnType<typeof availCardListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await availCardList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: availCardListQueryKey(options)
});

export const getApiThemeListQueryKey = (options: Options<GetApiThemeListData>) => createQueryKey('getApiThemeList', options);

/**
 * API 패키지 상품 목록 조회
 */
export const getApiThemeListOptions = (options: Options<GetApiThemeListData>) => queryOptions<GetApiThemeListResponse, GetApiThemeListError, GetApiThemeListResponse, ReturnType<typeof getApiThemeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiThemeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeListQueryKey(options)
});

export const getApiThemeListInfiniteQueryKey = (options: Options<GetApiThemeListData>): QueryKey<Options<GetApiThemeListData>> => createQueryKey('getApiThemeList', options, true);

/**
 * API 패키지 상품 목록 조회
 */
export const getApiThemeListInfiniteOptions = (options: Options<GetApiThemeListData>) => infiniteQueryOptions<GetApiThemeListResponse, GetApiThemeListError, InfiniteData<GetApiThemeListResponse>, QueryKey<Options<GetApiThemeListData>>, number | Pick<QueryKey<Options<GetApiThemeListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiThemeListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiThemeList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeListInfiniteQueryKey(options)
});

export const getApiThemeQueryKey = (options: Options<GetApiThemeData>) => createQueryKey('getApiTheme', options);

/**
 * API 패키지 상품 조회
 */
export const getApiThemeOptions = (options: Options<GetApiThemeData>) => queryOptions<GetApiThemeResponse, GetApiThemeError, GetApiThemeResponse, ReturnType<typeof getApiThemeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTheme({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeQueryKey(options)
});

export const getApiThemeNameListQueryKey = (options: Options<GetApiThemeNameListData>) => createQueryKey('getApiThemeNameList', options);

/**
 * API 패키지명 검색
 */
export const getApiThemeNameListOptions = (options: Options<GetApiThemeNameListData>) => queryOptions<GetApiThemeNameListResponse, GetApiThemeNameListError, GetApiThemeNameListResponse, ReturnType<typeof getApiThemeNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiThemeNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeNameListQueryKey(options)
});

export const getApiThemeNameListInfiniteQueryKey = (options: Options<GetApiThemeNameListData>): QueryKey<Options<GetApiThemeNameListData>> => createQueryKey('getApiThemeNameList', options, true);

/**
 * API 패키지명 검색
 */
export const getApiThemeNameListInfiniteOptions = (options: Options<GetApiThemeNameListData>) => infiniteQueryOptions<GetApiThemeNameListResponse, GetApiThemeNameListError, InfiniteData<GetApiThemeNameListResponse>, QueryKey<Options<GetApiThemeNameListData>>, number | Pick<QueryKey<Options<GetApiThemeNameListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiThemeNameListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiThemeNameList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeNameListInfiniteQueryKey(options)
});

export const getApiThemeKeywordNameListQueryKey = (options: Options<GetApiThemeKeywordNameListData>) => createQueryKey('getApiThemeKeywordNameList', options);

/**
 * API 패키지명 검색
 */
export const getApiThemeKeywordNameListOptions = (options: Options<GetApiThemeKeywordNameListData>) => queryOptions<GetApiThemeKeywordNameListResponse, GetApiThemeKeywordNameListError, GetApiThemeKeywordNameListResponse, ReturnType<typeof getApiThemeKeywordNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiThemeKeywordNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeKeywordNameListQueryKey(options)
});

export const getApiThemeKeywordNameListInfiniteQueryKey = (options: Options<GetApiThemeKeywordNameListData>): QueryKey<Options<GetApiThemeKeywordNameListData>> => createQueryKey('getApiThemeKeywordNameList', options, true);

/**
 * API 패키지명 검색
 */
export const getApiThemeKeywordNameListInfiniteOptions = (options: Options<GetApiThemeKeywordNameListData>) => infiniteQueryOptions<GetApiThemeKeywordNameListResponse, GetApiThemeKeywordNameListError, InfiniteData<GetApiThemeKeywordNameListResponse>, QueryKey<Options<GetApiThemeKeywordNameListData>>, number | Pick<QueryKey<Options<GetApiThemeKeywordNameListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiThemeKeywordNameListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiThemeKeywordNameList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeKeywordNameListInfiniteQueryKey(options)
});

export const getApiProductNameListQueryKey = (options: Options<GetApiProductNameListData>) => createQueryKey('getApiProductNameList', options);

/**
 * API 상품명 검색
 */
export const getApiProductNameListOptions = (options: Options<GetApiProductNameListData>) => queryOptions<GetApiProductNameListResponse, GetApiProductNameListError, GetApiProductNameListResponse, ReturnType<typeof getApiProductNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiProductNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiProductNameListQueryKey(options)
});

export const getApiPolicyListQueryKey = (options: Options<GetApiPolicyListData>) => createQueryKey('getApiPolicyList', options);

/**
 * API 개별 상품 목록 조회
 */
export const getApiPolicyListOptions = (options: Options<GetApiPolicyListData>) => queryOptions<GetApiPolicyListResponse, GetApiPolicyListError, GetApiPolicyListResponse, ReturnType<typeof getApiPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPolicyListQueryKey(options)
});

export const getApiPolicyListInfiniteQueryKey = (options: Options<GetApiPolicyListData>): QueryKey<Options<GetApiPolicyListData>> => createQueryKey('getApiPolicyList', options, true);

/**
 * API 개별 상품 목록 조회
 */
export const getApiPolicyListInfiniteOptions = (options: Options<GetApiPolicyListData>) => infiniteQueryOptions<GetApiPolicyListResponse, GetApiPolicyListError, InfiniteData<GetApiPolicyListResponse>, QueryKey<Options<GetApiPolicyListData>>, number | Pick<QueryKey<Options<GetApiPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiPolicyList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPolicyListInfiniteQueryKey(options)
});

export const getApiPolicyNameListQueryKey = (options: Options<GetApiPolicyNameListData>) => createQueryKey('getApiPolicyNameList', options);

/**
 * API 개별 상품명 검색
 */
export const getApiPolicyNameListOptions = (options: Options<GetApiPolicyNameListData>) => queryOptions<GetApiPolicyNameListResponse, GetApiPolicyNameListError, GetApiPolicyNameListResponse, ReturnType<typeof getApiPolicyNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPolicyNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPolicyNameListQueryKey(options)
});

export const getApiPolicyNameListInfiniteQueryKey = (options: Options<GetApiPolicyNameListData>): QueryKey<Options<GetApiPolicyNameListData>> => createQueryKey('getApiPolicyNameList', options, true);

/**
 * API 개별 상품명 검색
 */
export const getApiPolicyNameListInfiniteOptions = (options: Options<GetApiPolicyNameListData>) => infiniteQueryOptions<GetApiPolicyNameListResponse, GetApiPolicyNameListError, InfiniteData<GetApiPolicyNameListResponse>, QueryKey<Options<GetApiPolicyNameListData>>, number | Pick<QueryKey<Options<GetApiPolicyNameListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiPolicyNameListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiPolicyNameList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPolicyNameListInfiniteQueryKey(options)
});

export const findGoodPointTypesQueryKey = (options?: Options<FindGoodPointTypesData>) => createQueryKey('findGoodPointTypes', options);

/**
 * 좋았어요 항목 타입 목록 조회
 *
 * 투어 리뷰 작성/수정 시 사용 가능한 좋았어요 항목 타입(name, desc) 목록을 조회합니다.
 */
export const findGoodPointTypesOptions = (options?: Options<FindGoodPointTypesData>) => queryOptions<FindGoodPointTypesResponse, FindGoodPointTypesError, FindGoodPointTypesResponse, ReturnType<typeof findGoodPointTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGoodPointTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGoodPointTypesQueryKey(options)
});

export const findTourLclsSystmCodeListQueryKey = (options?: Options<FindTourLclsSystmCodeListData>) => createQueryKey('findTourLclsSystmCodeList', options);

/**
 * 분류체계 코드 목록
 *
 * rootCode / parentCode / depth 를 optional AND 필터로 적용하여 분류체계 코드 목록을 조회합니다. 페이징 없음, sort ASC 정렬.
 */
export const findTourLclsSystmCodeListOptions = (options?: Options<FindTourLclsSystmCodeListData>) => queryOptions<FindTourLclsSystmCodeListResponse, FindTourLclsSystmCodeListError, FindTourLclsSystmCodeListResponse, ReturnType<typeof findTourLclsSystmCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourLclsSystmCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourLclsSystmCodeListQueryKey(options)
});

export const findTourFestivalQueryKey = (options: Options<FindTourFestivalData>) => createQueryKey('findTourFestival', options);

/**
 * 축제 상세
 *
 * 축제 ID 로 상세 정보를 조회한다. 이미지, 반복정보, 프로그램, 테마 목록을 포함한다.
 */
export const findTourFestivalOptions = (options: Options<FindTourFestivalData>) => queryOptions<FindTourFestivalResponse, FindTourFestivalError, FindTourFestivalResponse, ReturnType<typeof findTourFestivalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourFestival({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFestivalQueryKey(options)
});

export const findTourReviewsQueryKey = (options: Options<FindTourReviewsData>) => createQueryKey('findTourReviews', options);

/**
 * 축제 리뷰 목록 조회
 *
 * 공개(deleteYN=false AND displayYN=true) 리뷰만 createAt DESC로 페이지 반환
 */
export const findTourReviewsOptions = (options: Options<FindTourReviewsData>) => queryOptions<FindTourReviewsResponse, FindTourReviewsError, FindTourReviewsResponse, ReturnType<typeof findTourReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourReviewsQueryKey(options)
});

export const findTourReviewsInfiniteQueryKey = (options: Options<FindTourReviewsData>): QueryKey<Options<FindTourReviewsData>> => createQueryKey('findTourReviews', options, true);

/**
 * 축제 리뷰 목록 조회
 *
 * 공개(deleteYN=false AND displayYN=true) 리뷰만 createAt DESC로 페이지 반환
 */
export const findTourReviewsInfiniteOptions = (options: Options<FindTourReviewsData>) => infiniteQueryOptions<FindTourReviewsResponse, FindTourReviewsError, InfiniteData<FindTourReviewsResponse>, QueryKey<Options<FindTourReviewsData>>, number | Pick<QueryKey<Options<FindTourReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindTourReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findTourReviews({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourReviewsInfiniteQueryKey(options)
});

export const findArticleQueryKey = (options: Options<FindArticleData>) => createQueryKey('findArticle', options);

/**
 * 아티클 상세
 *
 * 아티클 상세 정보와 매핑된 테마 목록을 조회한다.
 */
export const findArticleOptions = (options: Options<FindArticleData>) => queryOptions<FindArticleResponse, FindArticleError, FindArticleResponse, ReturnType<typeof findArticleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findArticle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findArticleQueryKey(options)
});

export const findArticleFeedbackQueryKey = (options: Options<FindArticleFeedbackData>) => createQueryKey('findArticleFeedback', options);

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * 아티클 의 조회수 정보를 조회한다.
 */
export const findArticleFeedbackOptions = (options: Options<FindArticleFeedbackData>) => queryOptions<FindArticleFeedbackResponse, FindArticleFeedbackError, FindArticleFeedbackResponse, ReturnType<typeof findArticleFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findArticleFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findArticleFeedbackQueryKey(options)
});

export const findThemeFestivalsQueryKey = (options: Options<FindThemeFestivalsData>) => createQueryKey('findThemeFestivals', options);

/**
 * 테마별 축제 목록
 *
 * 선택된 테마에 매핑된 TourFestival 카드 목록. subRegionCode 좌표 기준 거리(distance, 미터)를 포함하며, 진행중→예정→미정→종료 순 + 현재 월에 걸치는 축제 우선 + 거리 ASC로 정렬한다. status enum 포함 (페이지네이션).
 */
export const findThemeFestivalsOptions = (options: Options<FindThemeFestivalsData>) => queryOptions<FindThemeFestivalsResponse, FindThemeFestivalsError, FindThemeFestivalsResponse, ReturnType<typeof findThemeFestivalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findThemeFestivals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findThemeFestivalsQueryKey(options)
});

export const findThemeFestivalsInfiniteQueryKey = (options: Options<FindThemeFestivalsData>): QueryKey<Options<FindThemeFestivalsData>> => createQueryKey('findThemeFestivals', options, true);

/**
 * 테마별 축제 목록
 *
 * 선택된 테마에 매핑된 TourFestival 카드 목록. subRegionCode 좌표 기준 거리(distance, 미터)를 포함하며, 진행중→예정→미정→종료 순 + 현재 월에 걸치는 축제 우선 + 거리 ASC로 정렬한다. status enum 포함 (페이지네이션).
 */
export const findThemeFestivalsInfiniteOptions = (options: Options<FindThemeFestivalsData>) => infiniteQueryOptions<FindThemeFestivalsResponse, FindThemeFestivalsError, InfiniteData<FindThemeFestivalsResponse>, QueryKey<Options<FindThemeFestivalsData>>, number | Pick<QueryKey<Options<FindThemeFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindThemeFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findThemeFestivals({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findThemeFestivalsInfiniteQueryKey(options)
});

export const findThemeArticlesQueryKey = (options: Options<FindThemeArticlesData>) => createQueryKey('findThemeArticles', options);

/**
 * 테마별 Article 목록
 *
 * 선택된 테마에 매핑된 Article 카드 목록 (페이지네이션).
 */
export const findThemeArticlesOptions = (options: Options<FindThemeArticlesData>) => queryOptions<FindThemeArticlesResponse, FindThemeArticlesError, FindThemeArticlesResponse, ReturnType<typeof findThemeArticlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findThemeArticles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findThemeArticlesQueryKey(options)
});

export const findThemeArticlesInfiniteQueryKey = (options: Options<FindThemeArticlesData>): QueryKey<Options<FindThemeArticlesData>> => createQueryKey('findThemeArticles', options, true);

/**
 * 테마별 Article 목록
 *
 * 선택된 테마에 매핑된 Article 카드 목록 (페이지네이션).
 */
export const findThemeArticlesInfiniteOptions = (options: Options<FindThemeArticlesData>) => infiniteQueryOptions<FindThemeArticlesResponse, FindThemeArticlesError, InfiniteData<FindThemeArticlesResponse>, QueryKey<Options<FindThemeArticlesData>>, number | Pick<QueryKey<Options<FindThemeArticlesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FindThemeArticlesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await findThemeArticles({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findThemeArticlesInfiniteQueryKey(options)
});

export const findMonthlyThemesQueryKey = (options: Options<FindMonthlyThemesData>) => createQueryKey('findMonthlyThemes', options);

/**
 * 월별 테마 큐레이션 조회
 *
 * 전달받은 날짜의 월에 해당하는 테마 목록과 이전달/다음달 테마 존재 여부를 반환한다.
 */
export const findMonthlyThemesOptions = (options: Options<FindMonthlyThemesData>) => queryOptions<FindMonthlyThemesResponse, FindMonthlyThemesError, FindMonthlyThemesResponse, ReturnType<typeof findMonthlyThemesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findMonthlyThemes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findMonthlyThemesQueryKey(options)
});

/**
 * 회원 탈퇴(관리자용)
 */
export const resignMemberMutation = (options?: Partial<Options<ResignMemberData>>): UseMutationOptions<ResignMemberResponse, ResignMemberError, Options<ResignMemberData>> => {
    const mutationOptions: UseMutationOptions<ResignMemberResponse, ResignMemberError, Options<ResignMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resignMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * KB PAY 회원 탈회
 */
export const resignWelloWithKbPayMutation = (options?: Partial<Options<ResignWelloWithKbPayData>>): UseMutationOptions<ResignWelloWithKbPayResponse, ResignWelloWithKbPayError, Options<ResignWelloWithKbPayData>> => {
    const mutationOptions: UseMutationOptions<ResignWelloWithKbPayResponse, ResignWelloWithKbPayError, Options<ResignWelloWithKbPayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resignWelloWithKbPay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
